/* Welleasy Redesigned Cart */
function getCartState()
{
    const stateEl = document.querySelector('[data-ajax-cart-initial-state]');
    var result = null;

    if (stateEl)
    {
        try
        {
            result = { cart: JSON.parse(stateEl.textContent) };
        }
        catch (e) { /* invalid JSON */ }
    }

    return result;
}

function subscribeToCartStateUpdate(callback)
{
    function onCartRequestEnd()
    {
        const state = getCartState();
        if (state)
        {
            callback(state, null);
        }
    }

    document.addEventListener('liquid-ajax-cart:request-end', onCartRequestEnd);
}
function handleDeliveryToggleSwitch(container, switchTo)
{
    var autoshipView  = container.querySelector(".delivery-toggle-autoship");
    var onetimeView   = container.querySelector(".delivery-toggle-onetime");
    var hiddenInput   = container.querySelector(".delivery-schedule-input");

    if ( autoshipView && onetimeView )
    {
        if ( switchTo == "autoship" )
        {
            autoshipView.classList.add("active");
            onetimeView.classList.remove("active");
            if ( hiddenInput )
            {
                hiddenInput.value = "autoship";
            }
        }
        else
        {
            autoshipView.classList.remove("active");
            onetimeView.classList.add("active");
            if ( hiddenInput )
            {
                hiddenInput.value = "onetime";
            }
        }
    }
}

function handleDeliveryRadioChange(redesignedCart, radio)
{
    var deliveryType = radio.value;
    updateDeliverySavingsMessage(redesignedCart, deliveryType);
    updateAllItemsDeliverySchedule(redesignedCart, deliveryType);
}


function handleDeliverySwitchClick(e)
{
    var switchBtn;
    var switchTo;
    var container;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    
    switchBtn  = e.currentTarget;
    switchTo   = switchBtn.getAttribute("data-switch-to");
    container  = switchBtn.closest(".delivery-schedule-section");
    if (container && switchTo)
    {
        handleDeliveryToggleSwitch(container, switchTo);
    }
    
    return false;
}

function preserveQuizUpsellState()
{
    const isActive = sessionStorage.getItem( "quiz_upsell_active" ) == "true" || window.__quizUpsellActive;
    const view = document.querySelector(".quiz-autoship-view");
    const alreadyActive = view && view.classList.contains("cart-upsell-active");

    if (isActive && !alreadyActive && view)
    {
        view.classList.add("cart-upsell-active");
        const parent = view.closest(".welleasy-redesigned-cart");
        if (parent)
        {
            parent.classList.add("cart-upsell-active");
        }
        document.body.classList.add("cart-upsell-active");
    }
}

function handleDeliveryViewClick(e)
{
    const card = e.target.closest(".delivery-toggle-view");
    const isSwitch = e.target.closest(".js-delivery-switch");
    const section = card ? card.closest(".delivery-schedule-section") : null;
    const hasUpsell = document.querySelector(".quiz-autoship-view");

    if (card && !isSwitch && section && hasUpsell)
    {
        e.preventDefault();
        e.stopPropagation();
        const switchTo = card.classList.contains("delivery-toggle-autoship") ? "autoship" : "onetime";
        handleDeliveryToggleSwitch(section, switchTo);
        preserveQuizUpsellState();
    }
}

function initRedesignedCart()
{
    var redesignedCart   = document.querySelector(".welleasy-redesigned-cart");
    var deliverySwitches = null;
    var deliveryRadios   = null;
    var i;
    var j;
    var switchBtn;
    var radio;

    if ( redesignedCart )
    {
        deliverySwitches = redesignedCart.querySelectorAll(".js-delivery-switch");
        for ( i = 0; i < deliverySwitches.length; i++ )
        {
            switchBtn = deliverySwitches[i];
            switchBtn.addEventListener("click", handleDeliverySwitchClick);
        }
        deliveryRadios = redesignedCart.querySelectorAll(".delivery-radio");
        for ( j = 0; j < deliveryRadios.length; j++ )
        {
            radio = deliveryRadios[j];
            radio.addEventListener("change", function onDeliveryRadioChange()
            {
                handleDeliveryRadioChange(redesignedCart, radio);
            });
        }
        updateDeliveryOptionState(redesignedCart);
        setProgressBarWidth(redesignedCart);

        if (!window.__healthyAreasClickBound)
        {
            window.__healthyAreasClickBound = true;
            document.addEventListener("click", onHealthyAreasClick);
        }
    }
}

function onHealthyAreasClick(e)
{
    var seeAllBtn = e.target.closest(".healthy-areas-see-all");

    if (seeAllBtn)
    {
        var tags = document.getElementById("healthy-areas-tags");
        if (tags)
        {
            var isHidden = tags.hidden;
            tags.hidden = !isHidden;
            seeAllBtn.setAttribute("aria-expanded", !isHidden);
        }
    }

    var tabBtn = e.target.closest(".healthy-home-tab");

    if (tabBtn)
    {
        var category = tabBtn.getAttribute("data-category");
        var tabList = tabBtn.closest(".healthy-home-tab-list");

        if (category && tabList)
        {
            var tabs = tabList.querySelectorAll(".healthy-home-tab");
            for (var i = 0; i < tabs.length; i++)
            {
                tabs[i].classList.remove("active");
                tabs[i].setAttribute("aria-selected", "false");
            }
            tabBtn.classList.add("active");
            tabBtn.setAttribute("aria-selected", "true");

            var panelContainer = document.querySelector(".healthy-home-panels");
            if (panelContainer)
            {
                var panels = panelContainer.querySelectorAll(".healthy-home-panel");
                for (var p = 0; p < panels.length; p++)
                {
                    var panelCategory = panels[p].getAttribute("data-category");
                    if (panelCategory == category)
                    {
                        panels[p].classList.remove("hidden");
                    }
                    else
                    {
                        panels[p].classList.add("hidden");
                    }
                }
            }
        }
    }
}

function isValidAutoshipToggle(toggle)
{
    var hasValue      = toggle.value && toggle.value.trim() != "";
    var hasAction     = toggle.getAttribute("data-action");
    var isSellingPlan = toggle.getAttribute("title") == "selling_plan" ||
                        (hasAction && hasAction.indexOf("selling_plan") != -1) ||
                        toggle.name == "cart-item-selling-plan";

    return hasValue && hasAction && isSellingPlan;
}

function addToggleIfValid(allToggles, toggle)
{
    if (isValidAutoshipToggle(toggle) && allToggles.indexOf(toggle) == -1)
    {
        allToggles.push(toggle);
    }
}

function collectTogglesForSelector(allToggles, selector)
{
    var found = document.querySelectorAll(selector);
    found.forEach(function addToggle(toggle)
    {
        addToggleIfValid(allToggles, toggle);
    });
}

function findAllAutoshipToggles()
{
    var selectors = [
        "input[data-ajax-cart-request-button-new][title='selling_plan']",
        "input[name='cart-item-selling-plan'][data-ajax-cart-request-button-new]",
        "input[data-ajax-cart-request-button-new]"
    ];

    var allToggles = [];

    selectors.forEach(function processSelector(selector)
    {
        collectTogglesForSelector(allToggles, selector);
    });

    return allToggles;
}

// function mergeSecondPassToggles(allToggles)
// {
//     const secondPassToggles = findAllAutoshipToggles();

//     secondPassToggles.forEach(function mergeToggle(toggle)
//     {
//         if (allToggles.indexOf(toggle) == -1)
//         {
//             allToggles.push(toggle);
//         }
//     });
// }

// function processSecondPass(allToggles, deliveryType, container)
// {
//     mergeSecondPassToggles(allToggles);
//     processToggles(allToggles, deliveryType, container);
// }

// function scheduleProcessSecondPass(allToggles, deliveryType, container)
// {
//     setTimeout(function onProcessSecondPass()
//     {
//         processSecondPass(allToggles, deliveryType, container);
//     }, 150);
// }

function setUpRedesignedCartAutoshipSwitches()
{
    // Disabled for now - let default handlers work
}

async function removeLines( variantId )
{
    const updates = {};

    variantId.forEach(function setUpdateKey(key)
    {
        updates[key] = 0;
    });

    await fetch( '/cart/update.js',
    {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates })
    });
}

async function addLines( items )
{
    var response = await fetch( '/cart/add.js',
    {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items, sections: "cart-drawer-section,cart-products-auto-render,welleasy-new-cart-template" })
    });
    var data = await response.json();
    var sectionHtml = data.sections && data.sections["welleasy-new-cart-template"];
    if ( sectionHtml )
    {
        var container = document.getElementById("shopify-section-welleasy-new-cart-template");
        if ( container )
        {
            container.innerHTML = sectionHtml;
        }
    }
    preserveQuizUpsellState();
}

async function swapSellingPlans( batch ) {
    const cart = await fetch( '/cart.js' ).then(function parseCartJson(r) { return r.json(); });

    const toRemove = [ ];
    const toAdd = [ ];

    batch.forEach(function processSwapItem(batchItem)
    {
        var line;
        line = cart.items.find(function matchVariantId(item) { return item.id == batchItem.variantId; });
        if (line)
        {
            toRemove.push(line.key);
            toAdd.push(
            {
                id: line.variant_id,
                quantity: line.quantity,
                selling_plan: (batchItem.sellingPlanId == "") ? null : batchItem.sellingPlanId,
                properties: line.properties
            });
        }
    });

    if ( toRemove.length && toAdd.length )
    {
        await removeLines(toRemove);
        await addLines(toAdd);
    }
}

function updateAllItemsDeliverySchedule(container, deliveryType)
{
    var allSwitches;
    var switchArray;
    var i;
    var switchEl;
    var $switch;
    var currentChecked;
    var shouldBeChecked;
    var switchesToUpdate;
    var updates;
    var variantId;
    var sellingPlanId;

    allSwitches = container.querySelectorAll("input[data-ajax-cart-request-button-new][title='selling_plan']");
    if ( allSwitches && allSwitches.length != 0 )
    {
        switchArray    = Array.from(allSwitches);
        shouldBeChecked = (deliveryType == "autoship");
        switchesToUpdate = [];
        for ( i = 0; i < switchArray.length; i++ )
        {
            switchEl = switchArray[i];
            $switch = $(switchEl);
            currentChecked = $switch.prop("checked");
            if ( currentChecked != shouldBeChecked )
            {
                switchesToUpdate.push(switchEl);
            }
        }
        updates = [];
        for ( i = 0; i < switchesToUpdate.length; i++ )
        {
            variantId = switchesToUpdate[i].dataset.variant;
            sellingPlanId = switchesToUpdate[i].dataset.sellingPlanId;
            updates.push( { "variantId": variantId, "sellingPlanId": sellingPlanId } );
        }
        swapSellingPlans( updates );
    }
}

function triggerToggleClick(toggle)
{
    if (!toggle.checked)
    {
        toggle.checked = true;
    }
    toggle.click();
}

function triggerDisableToggleClick(toggle)
{
    if (toggle.checked)
    {
        toggle.checked = false;
    }
    toggle.click();
}

function scheduleTriggerToggleClick(toggle, index)
{
    setTimeout(function onTriggerToggleClick()
    {
        triggerToggleClick(toggle);
    }, index * 250);
}

function enableAutoshipToggle(toggle, index, clickedCount)
{
    var wasChecked = toggle.checked;

    if (!wasChecked)
    {
        clickedCount.value++;

        var currentAction = toggle.getAttribute("data-action") || "";
        var sellingPlanId = toggle.value;

        if (sellingPlanId && currentAction && !currentAction.includes("selling_plan=" + sellingPlanId))
        {
            var urlMatch = currentAction.match(/line=(\d+)&quantity=(\d+)/);
            if (urlMatch)
            {
                var line     = urlMatch[1];
                var quantity = urlMatch[2];
                toggle.setAttribute("data-action", "/cart/change?line=" + line + "&quantity=" + quantity + "&selling_plan=" + sellingPlanId);
            }
        }

        toggle.checked = true;

        scheduleTriggerToggleClick(toggle, index);
    }
}

function scheduleTriggerDisableToggleClick(toggle, index)
{
    setTimeout(function onTriggerDisableToggleClick()
    {
        triggerDisableToggleClick(toggle);
    }, index * 250);
}

function disableAutoshipToggle(toggle, index, clickedCount)
{
    var wasChecked = toggle.checked;

    if (wasChecked)
    {
        clickedCount.value++;

        var currentAction = toggle.getAttribute("data-action") || "";

        if (currentAction && currentAction.includes("selling_plan="))
        {
            var urlMatch = currentAction.match(/line=(\d+)&quantity=(\d+)/);
            if (urlMatch)
            {
                var line     = urlMatch[1];
                var quantity = urlMatch[2];
                toggle.setAttribute("data-action", "/cart/change?line=" + line + "&quantity=" + quantity + "&selling_plan=");
            }
        }

        toggle.checked = false;

        scheduleTriggerDisableToggleClick(toggle, index);
    }
}

function processToggles(allToggles, deliveryType, container)
{
    var clickedCount = { value: 0 };

    if (deliveryType == "autoship")
    {
        allToggles.forEach(function enableToggle(toggle, index)
        {
            enableAutoshipToggle(toggle, index, clickedCount);
        });
    }
    else if (deliveryType == "onetime")
    {
        allToggles.forEach(function disableToggle(toggle, index)
        {
            disableAutoshipToggle(toggle, index, clickedCount);
        });
    }

    setTimeout(function onUpdateDeliveryOptionState()
    {
        updateDeliveryOptionState(container);
    }, (allToggles.length * 250) + 500);
}

function updateDeliverySavingsMessage(container, deliveryType)
{
    var savingsHeader   = container.querySelector(".delivery-savings-header");
    var existingStrong  = null;
    var savingsFormatted = "£0.00";
    var savingsAmount   = null;
    var pounds          = 0;

    if ( savingsHeader )
    {
        existingStrong = savingsHeader.querySelector("strong");
        if ( existingStrong )
        {
            savingsFormatted = existingStrong.textContent.trim();
        }
        else
        {
            savingsAmount   = savingsHeader.getAttribute("data-savings-amount") || "0";
            pounds          = parseFloat(savingsAmount) / 100;
            savingsFormatted = "£" + pounds.toFixed(2);
        }
        if ( deliveryType == "autoship" )
        {
            savingsHeader.innerHTML = "You're saving <strong>" + savingsFormatted + "</strong> with Autoship – delivered every 4 weeks, so you never run out";
        }
        else
        {
            savingsHeader.innerHTML = "Switch to Autoship and save 5% more – delivered every 4 weeks so you never run out";
        }
    }
}

function updateDeliveryOption(option, hasAutoship)
{
    const radio = option.querySelector(".delivery-radio");

    if (hasAutoship && option.dataset.deliveryType == "autoship")
    {
        option.classList.add("selected");
        if (radio)
        {
            radio.checked = true;
        }
    }
    else if (!hasAutoship && option.dataset.deliveryType == "onetime")
    {
        option.classList.add("selected");
        if (radio)
        {
            radio.checked = true;
        }
    }
    else
    {
        option.classList.remove("selected");
    }
}

function setProgressBarWidth(container)
{
    const progressBar = container.querySelector(".cart-delivery-progress-bar[data-progress-width]");
    if (progressBar)
    {
        const progressWidth = progressBar.getAttribute("data-progress-width");
        if (progressWidth)
        {
            progressBar.style.setProperty("--progress-width", progressWidth);
        }
    }
}

function updateDeliveryOptionState(container)
{
    const autoshipToggles = container.querySelectorAll("input[data-ajax-cart-request-button-new][title='selling_plan']");
    const hasAutoship     = Array.from(autoshipToggles).some(function checkChecked(toggle)
    {
        return toggle.checked;
    });

    const deliveryOptions = container.querySelectorAll(".delivery-option");
    deliveryOptions.forEach(function updateOption(option)
    {
        updateDeliveryOption(option, hasAutoship);
    });

    const deliveryType = hasAutoship ? "autoship" : "onetime";
    updateDeliverySavingsMessage(container, deliveryType);
}

function setUpRedesignedCartQuantityHandlers()
{
    // Disabled - using base cart quantity selectors
    // Base cart handles quantity selectors via setUpCartEventsWellEasy()
}

function handleCartStateUpdate(state, prevState)
{
    setTimeout(function onCartStateUpdateDelayed()
    {
        initRedesignedCart();
        if (state && state.cart)
        {
            updateRedesignedCartContent(state.cart);
            updateHealthyAreasBanner(state.cart);
            renderLockedGiftTeaser(state.cart);
        }
        enforceFreeGiftRules();
        // Base cart handles quantity selectors via setUpCartEventsWellEasy()
    }, 100);
}

function handleCartRequestEnd()
{
    setTimeout(function onCartRequestEndDelayed()
    {
        // Clear all processing flags and re-enable buttons
        var redesignedCart = document.querySelector(".welleasy-redesigned-cart");
        if (redesignedCart)
        {
            var $allButtons = $(redesignedCart).find('.cart-quantity-value-change');
            
            // Clear all safety timeouts
            $allButtons.each( function clearCartButtonSafetyTimeout( )
            {
                var $btn    = $( this );
                var timeout = $btn.data( "safetyTimeout" );
                if ( timeout )
                {
                    clearTimeout( timeout );
                    $btn.removeData( "safetyTimeout" );
                }
            } );
            
            // Clear processing flags and re-enable buttons
            $allButtons.data('processing', false);
            $allButtons.removeClass('disabled').css('pointer-events', '');
            
            // Check each plus button against inventory limits
            $allButtons.filter( "[data-type=\"plus\"]" ).each( function checkPlusButtonInventory( )
            {
                var $plusButton = $( this );
                var $qtyInput = $plusButton.closest('.cart-quantity').find('input.cart-quantity-value');
                
                if ($qtyInput.length)
                {
                    var currentQty = parseInt($qtyInput.val(), 10) || 0;
                    var maxQty = $qtyInput.attr('data-max');
                    
                    if (maxQty)
                    {
                        var maxQuantity = parseInt(maxQty, 10);
                        if (!isNaN(maxQuantity) && currentQty >= maxQuantity)
                        {
                            // At max inventory - keep unchangeable class
                            $plusButton.addClass('cart-quantity-value-unchangeable');
                        }
                        else
                        {
                            // Can increase - remove unchangeable class
                            $plusButton.removeClass('cart-quantity-value-unchangeable');
                        }
                    }
                    else
                    {
                        // No max limit - can always increase
                        $plusButton.removeClass('cart-quantity-value-unchangeable');
                    }
                }
            });
        }
        
        initRedesignedCart();
        var cartState = getCartState();
        if (cartState && cartState.cart)
        {
            updateRedesignedCartContent(cartState.cart);
            updateHealthyAreasBanner(cartState.cart);
            renderLockedGiftTeaser(cartState.cart);
        }
        enforceFreeGiftRules();
        // Base cart handles quantity selectors via setUpCartEventsWellEasy()
    }, 100);
}

function handleMutationForReinit(mutations)
{
    var shouldReinit = false;
    mutations.forEach(function checkMutation(mutation)
    {
        if (mutation.type == "childList" && mutation.addedNodes.length > 0)
        {
            shouldReinit = true;
        }
    });
    if (shouldReinit)
    {
        setTimeout(function onReinitDelayed()
        {
            initRedesignedCart();
        }, 50);
    }
}

function addItemToTotalRrp(totalRrp, item)
{
    if (item.variant && item.variant.compare_at_price)
    {
        return totalRrp + (item.variant.compare_at_price * item.quantity);
    }
    if (item.compare_at_price)
    {
        return totalRrp + (item.compare_at_price * item.quantity);
    }
    return totalRrp;
}

function addItemToTotalSavings(totalSavings, item)
{
    var comparePrice = 0;
    if (item.variant && item.variant.compare_at_price)
    {
        comparePrice = item.variant.compare_at_price * item.quantity;
    }
    else if (item.compare_at_price)
    {
        comparePrice = item.compare_at_price * item.quantity;
    }
    if (comparePrice > item.final_line_price)
    {
        return totalSavings + (comparePrice - item.final_line_price);
    }
    return totalSavings;
}

function updateCartItemInRedesignedCart(item)
{
    var cartItem         = document.querySelector(".welleasy-redesigned-cart .we_cart_item[data-variant-id='" + item.variant_id + "']");
    var qtyInput         = null;
    var minusButton      = null;
    var plusButton       = null;
    var lineNumber       = null;
    var newMinusQuantity = 0;
    var newMinusHref     = "";
    var newPlusHref      = "";
    var maxQuantity      = null;
    var canIncrease      = true;
    var maxQty           = 0;
    var priceEl          = null;
    var comparePrice     = 0;
    var wasPriceEl       = null;
    var reductionEl      = null;
    var diff             = 0;
    var diffPC           = 0;

    if ( !cartItem )
    {
        cartItem = document.querySelector(".welleasy-redesigned-cart .products-in-cart[data-variant-id='" + item.variant_id + "']");
    }
    if ( cartItem )
    {
        qtyInput = cartItem.querySelector(".cart-quantity-value");
        if ( qtyInput )
        {
            qtyInput.value = item.quantity;
            qtyInput.setAttribute("data-initial-value", item.quantity);
            if ( item.variant && item.variant.inventory_management == "shopify" && item.variant.inventory_policy == "deny" && item.variant.inventory_quantity )
            {
                qtyInput.setAttribute("data-max", item.variant.inventory_quantity);
            }
            else
            {
                qtyInput.removeAttribute("data-max");
            }
        }
        minusButton = cartItem.querySelector(".cart-quantity-value-change[data-type='minus']");
        plusButton = cartItem.querySelector(".cart-quantity-value-change[data-type='plus']");
        lineNumber = qtyInput ? (qtyInput.getAttribute("data-line") || qtyInput.getAttribute("data-ajax-cart-quantity-input")) : null;
        if ( lineNumber )
        {
            if ( minusButton )
            {
                newMinusQuantity = Math.max(1, item.quantity - 1);
                newMinusHref = "/cart/change?line=" + lineNumber + "&quantity=" + newMinusQuantity;
                minusButton.setAttribute("href", newMinusHref);
            }
            if ( plusButton )
            {
                newPlusHref = "/cart/change?line=" + lineNumber + "&quantity=" + (item.quantity + 1);
                plusButton.setAttribute("href", newPlusHref);
            }
            if ( minusButton )
            {
                $(minusButton).data("processing", false);
                minusButton.classList.remove("disabled");
                minusButton.style.pointerEvents = "";
            }
            if ( plusButton )
            {
                maxQuantity = qtyInput ? (qtyInput.getAttribute("data-max") || null) : null;
                canIncrease = true;
                if ( maxQuantity )
                {
                    maxQty = parseInt(maxQuantity, 10);
                    canIncrease = (isNaN(maxQty) || item.quantity < maxQty);
                }
                $(plusButton).data("processing", false);
                plusButton.classList.remove("disabled");
                plusButton.style.pointerEvents = "";
                if ( canIncrease )
                {
                    plusButton.classList.remove("cart-quantity-value-unchangeable");
                }
                else
                {
                    plusButton.classList.add("cart-quantity-value-unchangeable");
                }
            }
        }
        cartItem.setAttribute("data-cart-item-quantity", item.quantity);
        cartItem.setAttribute("data-cart-item-price", item.final_price);
        priceEl = cartItem.querySelector(".cart-price .item-final-price");
        if ( priceEl )
        {
            priceEl.innerHTML = Shopify.formatMoney(item.final_line_price);
        }
        comparePrice = 0;
        if ( item.variant && item.variant.compare_at_price )
        {
            comparePrice = item.variant.compare_at_price * item.quantity;
        }
        else if ( item.compare_at_price )
        {
            comparePrice = item.compare_at_price * item.quantity;
        }
        wasPriceEl  = cartItem.querySelector(".cart-price .item-was-price");
        reductionEl = cartItem.querySelector(".cart-price .item-reduction");
        if ( comparePrice > item.final_line_price )
        {
            diff   = comparePrice - item.final_line_price;
            diffPC = Math.round((diff * 100) / comparePrice);
            if ( wasPriceEl )
            {
                wasPriceEl.innerHTML = Shopify.formatMoney(comparePrice) + " ";
                wasPriceEl.parentElement.style.visibility = "";
            }
            if ( reductionEl )
            {
                reductionEl.innerHTML = "-" + diffPC + "%";
            }
        }
        else if ( wasPriceEl )
        {
            wasPriceEl.parentElement.style.visibility = "hidden";
        }
    }
}

function isVariantInCart(items, variantId)
{
    return items.some(function itemMatchesVariant(item)
    {
        return item.variant_id == variantId;
    });
}

function removeCartItemIfNotInCart(cartItemEl, items)
{
    var variantId   = cartItemEl.getAttribute("data-variant-id");
    var stillInCart = isVariantInCart(items, variantId);

    if (!stillInCart)
    {
        var nextEl = cartItemEl.nextElementSibling;
        if (nextEl && nextEl.tagName == "HR")
        {
            nextEl.remove();
        }
        cartItemEl.remove();
    }
}

function addItemToAutoshipSavings(autoshipSavings, item)
{
    var sellingPlan;
    var adjustment;
    var discountMultiplier;
    var memberPrice;
    var itemSavings;
    var result;
    var skip;
    var themeSettings;

    result = autoshipSavings;
    skip   = (item.product_type && item.product_type.toLowerCase().includes("membership"));
    themeSettings = (window.theme && window.theme.settings) || {};
    if (themeSettings.annual_subscription_product) { skip = skip || (item.product_id == themeSettings.annual_subscription_product.id); }
    if (themeSettings.monthly_subscription_product) { skip = skip || (item.product_id == themeSettings.monthly_subscription_product.id); }
    if (themeSettings.legacy_annual_subscription_product) { skip = skip || (item.product_id == themeSettings.legacy_annual_subscription_product.id); }

    if (!skip)
    {
        sellingPlan = null;
        if (item.selling_plan_allocation && item.selling_plan_allocation.selling_plan)
        {
            sellingPlan = item.selling_plan_allocation.selling_plan;
        }

        if (sellingPlan && sellingPlan.price_adjustments && sellingPlan.price_adjustments.length > 0)
        {
            adjustment  = sellingPlan.price_adjustments[0];
            memberPrice = item.final_line_price;

            if (adjustment.value_type == "percentage" && adjustment.value > 0)
            {
                discountMultiplier = 100 - adjustment.value;
                itemSavings        = (item.final_line_price * 100 / discountMultiplier) - item.final_line_price;
                result             = autoshipSavings + itemSavings;
            }
            else if (adjustment.value_type == "fixed_amount" && adjustment.value > 0)
            {
                result = autoshipSavings + (adjustment.value * item.quantity);
            }
        }
    }
    return result;
}

function getItemComparePrice(item)
{
    var comparePrice = 0;
    if (item.variant && item.variant.compare_at_price)
    {
        comparePrice = item.variant.compare_at_price * item.quantity;
    }
    else if (item.compare_at_price)
    {
        comparePrice = item.compare_at_price * item.quantity;
    }
    return comparePrice;
}

function addItemToMemberSavings(memberSavings, item)
{
    var comparePrice;
    var memberPrice;
    var priceAdjustments;
    var adjustment;
    var discountMultiplier;
    var result;
    var skip;
    var themeSettings;

    result = memberSavings;
    skip   = (item.product_type && item.product_type.toLowerCase().includes("membership"));
    themeSettings = (window.theme && window.theme.settings) || {};
    if (themeSettings.annual_subscription_product) { skip = skip || (item.product_id == themeSettings.annual_subscription_product.id); }
    if (themeSettings.monthly_subscription_product) { skip = skip || (item.product_id == themeSettings.monthly_subscription_product.id); }
    if (themeSettings.legacy_annual_subscription_product) { skip = skip || (item.product_id == themeSettings.legacy_annual_subscription_product.id); }

    if (!skip)
    {
        comparePrice = getItemComparePrice(item);
        if (comparePrice > 0)
        {
            memberPrice = item.final_line_price;
            if (item.selling_plan_allocation)
            {
                priceAdjustments = item.selling_plan_allocation.selling_plan.price_adjustments;
                if (priceAdjustments && priceAdjustments.length > 0)
                {
                    adjustment = priceAdjustments[0];
                    if (adjustment.value_type == "percentage" && adjustment.value > 0)
                    {
                        discountMultiplier = 100 - adjustment.value;
                        if (discountMultiplier > 0)
                        {
                            memberPrice = Math.round((item.final_line_price * 100) / discountMultiplier);
                        }
                    }
                    else if (adjustment.value_type == "fixed_amount" && adjustment.value > 0)
                    {
                        memberPrice = item.final_line_price + (adjustment.value * item.quantity);
                    }
                }
            }
            if (comparePrice > memberPrice)
            {
                result = memberSavings + (comparePrice - memberPrice);
            }
        }
    }
    return result;
}

function updateRedesignedCartContent(cart)
{
    // Normalize cart object - handle different structures
    var cartData = cart.cart || cart;
    
    var autoshipSavingsCalculated  = 0;
    var totalRrpForCorrection       = 0;
    var totalSubtotalForCorrection  = cartData.items_subtotal_price || 0;
    
    if (cartData.items && cartData.items.length > 0)
    {
        var i;
        var item;
        for (i = 0; i < cartData.items.length; i++)
        {
            item = cartData.items[i];
            autoshipSavingsCalculated = addItemToAutoshipSavings(autoshipSavingsCalculated, item);
            totalRrpForCorrection = totalRrpForCorrection + getItemComparePrice(item);
        }
    }
    
    var roundedAutoshipSavings  = Math.round(autoshipSavingsCalculated);
    var formattedAutoshipSavings = Shopify.formatMoney(roundedAutoshipSavings);
    
    var cartCountEl = document.querySelector(".welleasy-redesigned-cart .cart-page-title span");
    if (cartCountEl && cartData.item_count != undefined)
    {
        cartCountEl.textContent = cartData.item_count;
    }

    var subtotalEl = document.querySelector(".welleasy-redesigned-cart .order-summary-subtotal .subtotal-amount strong");
    if (subtotalEl && cartData.items_subtotal_price != undefined)
    {
        subtotalEl.innerHTML = Shopify.formatMoney(cartData.items_subtotal_price);
    }

    var subtotalAmountEl = document.querySelector(".welleasy-redesigned-cart .order-summary-subtotal .subtotal-amount");
    var rrpEl = document.querySelector(".welleasy-redesigned-cart .order-summary-subtotal .rrp-amount");
    if (cartData.items && cartData.items.length > 0)
    {
        var totalRrp = 0;
        var i;
        var item;
        for (i = 0; i < cartData.items.length; i++)
        {
            item = cartData.items[i];
            totalRrp = addItemToTotalRrp(totalRrp, item);
        }

        if (!rrpEl && subtotalAmountEl)
        {
            rrpEl = document.createElement("span");
            rrpEl.className = "rrp-amount";
            subtotalAmountEl.appendChild(rrpEl);
        }
        
        if (rrpEl)
        {
            if (totalRrp > cartData.items_subtotal_price)
            {
                rrpEl.innerHTML     = "(RRP <span class=\"rrp-price\">" + Shopify.formatMoney(totalRrp) + "</span>)";
                rrpEl.style.display = "";
            }
            else
            {
                rrpEl.style.display = "none";
            }
        }
    }

    var itemCountEl = document.querySelector(".welleasy-redesigned-cart .order-summary-subtotal .item-count");
    if (itemCountEl && cartData.item_count != undefined)
    {
        itemCountEl.textContent = cartData.item_count + " items";
    }

    if (cartData.items && cartData.items.length > 0)
    {
        var totalSavings = 0;
        cartData.items.forEach(function sumSavingsForItem(item)
        {
            totalSavings = addItemToTotalSavings(totalSavings, item);
        });

        // cart-saving-message is hidden
        var savingsEl = document.querySelector(".welleasy-redesigned-cart .cart-saving-message");
        if (savingsEl)
        {
            savingsEl.style.display = "none";
        }
    }

    // Remove items from DOM that are no longer in the cart
    if (cartData.items)
    {
        var allCartItems = document.querySelectorAll(".welleasy-redesigned-cart .we_cart_item[data-variant-id]");
        for (var r = 0; r < allCartItems.length; r++)
        {
            removeCartItemIfNotInCart(allCartItems[r], cartData.items);
        }
    }

    setTimeout(function rebindCartEvents()
    {
        setUpCartEventsWellEasy();
        stripLiquidCartAttrFromCartPageButtons();
    }, 100);

    var progressBar  = document.querySelector(".welleasy-redesigned-cart .cart-delivery-progress-bar");
    var progressInfo = document.querySelector(".welleasy-redesigned-cart .cart-delivery-progress-info");
    if (progressBar && cartData.items_subtotal_price != undefined)
    {
        var freeDeliveryCriteria = 3900;
        var freeDeliveryDiff     = freeDeliveryCriteria - cartData.items_subtotal_price;

        if (freeDeliveryDiff <= 0)
        {
            progressBar.setAttribute("data-progress-width", "100%");
            var innerBar = progressBar.querySelector(".cart-delivery-progress-bar-inner");
            if (innerBar)
            {
                innerBar.style.width = "100%";
            }
            if (progressInfo)
            {
                progressInfo.innerHTML = "<p>You qualify for free delivery</p>";
            }
        }
        else
        {
            var progress = Math.min(100, (cartData.items_subtotal_price / freeDeliveryCriteria) * 100);
            progressBar.setAttribute("data-progress-width", progress + "%");
            var innerBar = progressBar.querySelector(".cart-delivery-progress-bar-inner");
            if (innerBar)
            {
                innerBar.style.width = progress + "%";
            }
            if (progressInfo)
            {
                progressInfo.innerHTML = "<p>Add <strong>" + Shopify.formatMoney(freeDeliveryDiff) + "</strong> for <strong>FREE shipping</strong></p>";
            }
        }
    }

    var deliveryToggleSavings = document.querySelector(".welleasy-redesigned-cart .delivery-toggle-savings strong");
    if (deliveryToggleSavings)
    {
        deliveryToggleSavings.innerHTML = formattedAutoshipSavings;
    }

    var onetimeSavingsStrongs = document.querySelectorAll(".welleasy-redesigned-cart .delivery-toggle-onetime-savings strong, .welleasy-redesigned-cart .delivery-toggle-switch-onetime-btn strong");
    var j;
    var el;
    for (j = 0; j < onetimeSavingsStrongs.length; j++)
    {
        el = onetimeSavingsStrongs[j];
        el.innerHTML = formattedAutoshipSavings;
    }

    var deliveryScheduleSection = document.querySelector(".welleasy-redesigned-cart .delivery-schedule-section");
    if (deliveryScheduleSection)
    {
        deliveryScheduleSection.setAttribute("data-savings-amount", roundedAutoshipSavings);
    }
    
    var groceryBoxPrice = document.querySelector(".welleasy-redesigned-cart .grocery-box-price");
    if (groceryBoxPrice && cartData.items_subtotal_price != undefined)
    {
        if (cartData.items_subtotal_price >= 3900)
        {
            groceryBoxPrice.textContent = "FREE";
        }
        else
        {
            var defaultPrice = groceryBoxPrice.getAttribute("data-default-price") || "£4.99";
            groceryBoxPrice.textContent = defaultPrice;
        }
    }
    
    var orderSummarySubtotal = document.querySelector(".welleasy-redesigned-cart .order-summary-subtotal");
    var savingsBreakdown      = document.querySelector(".welleasy-redesigned-cart .order-savings-breakdown");
    
    if (!savingsBreakdown && orderSummarySubtotal && cartData.items)
    {
        savingsBreakdown = document.createElement("div");
        savingsBreakdown.className = "order-savings-breakdown";
        orderSummarySubtotal.parentElement.insertBefore(savingsBreakdown, orderSummarySubtotal.nextSibling);
    }
    
    if (savingsBreakdown && cartData.items)
    {
        var totalRrp               = 0;
        var hasActiveAutoshipItems  = false;
        var k;
        var savingsItem;

        for (k = 0; k < cartData.items.length; k++)
        {
            savingsItem = cartData.items[k];
            totalRrp = totalRrp + getItemComparePrice(savingsItem);
            if (savingsItem.selling_plan_allocation)
            {
                hasActiveAutoshipItems = true;
            }
        }
        
        var cartSubtotal            = cartData.items_subtotal_price || 0;
        var cartTotalBeforeAutoship = cartSubtotal + autoshipSavingsCalculated;
        var memberSavings           = totalRrp - cartTotalBeforeAutoship;
        var roundedMemberSavings    = Math.round(memberSavings);
        
        roundedMemberSavings = roundedMemberSavings - 2;
        if (roundedMemberSavings < 0)
        {
            roundedMemberSavings = 0;
        }
        
        var memberSavingsRow = savingsBreakdown.querySelector(".member-savings-row");
        
        if (memberSavingsRow)
        {
            var memberSavingsAmount = memberSavingsRow.querySelector(".savings-amount");
            if (memberSavingsAmount)
            {
                if (roundedMemberSavings > 0)
                {
                    memberSavingsAmount.textContent = "-" + Shopify.formatMoney(roundedMemberSavings);
                    memberSavingsRow.removeAttribute("style");
                    memberSavingsRow.style.display = "";
                }
                else
                {
                    memberSavingsRow.style.display = "none";
                }
            }
        }
        else
        {
            var memberRow = document.createElement("div");
            memberRow.className = "savings-row member-savings-row";
            memberRow.innerHTML = '<span class="savings-label">Member Savings:</span><span class="savings-amount">-' + Shopify.formatMoney(roundedMemberSavings) + '</span>';
            if (memberSavings > 0)
            {
                memberRow.style.display = "";
            }
            else
            {
                memberRow.style.display = "none";
            }
            if (savingsBreakdown.firstChild)
            {
                savingsBreakdown.insertBefore(memberRow, savingsBreakdown.firstChild);
            }
            else
            {
                savingsBreakdown.appendChild(memberRow);
            }
        }
        
        var autoshipRow = savingsBreakdown.querySelector(".autoship-savings-row");
        
        if (autoshipRow)
        {
            var autoshipSavingsAmount = autoshipRow.querySelector(".savings-amount");
            if (autoshipSavingsAmount)
            {
                // Use EXACT same formatted value as top banner - no recalculation
                autoshipSavingsAmount.textContent = "-" + formattedAutoshipSavings;
                if (hasActiveAutoshipItems && roundedAutoshipSavings > 0)
                {
                    autoshipRow.removeAttribute("style");
                    autoshipRow.style.display = "";
                }
                else
                {
                    autoshipRow.style.display = "none";
                }
            }
        }
        else
        {
            var autoshipRowNew = document.createElement("div");
            autoshipRowNew.className = "savings-row autoship-savings-row";
            autoshipRowNew.innerHTML = '<span class="savings-label">Autoship Savings:</span><span class="savings-amount">-' + formattedAutoshipSavings + '</span>';
            if (hasActiveAutoshipItems && roundedAutoshipSavings > 0)
            {
                autoshipRowNew.style.display = "";
            }
            else
            {
                autoshipRowNew.style.display = "none";
            }
            var insertAfter = savingsBreakdown.querySelector(".member-savings-row");
            if (insertAfter)
            {
                insertAfter.parentElement.insertBefore(autoshipRowNew, insertAfter.nextSibling);
            }
            else
            {
                savingsBreakdown.appendChild(autoshipRowNew);
            }
        }
        
        var orderDiscountRow = savingsBreakdown.querySelector(".order-discount-row");
        if (cartData.cart_level_discount_applications && cartData.cart_level_discount_applications.length > 0)
        {
            var totalDiscount = 0;
            var m;
            var discount;
            for (m = 0; m < cartData.cart_level_discount_applications.length; m++)
            {
                discount = cartData.cart_level_discount_applications[m];
                totalDiscount += discount.total_allocated_amount || 0;
            }
            
            if (orderDiscountRow)
            {
                var discountAmount = orderDiscountRow.querySelector(".discount-amount");
                if (discountAmount && totalDiscount > 0)
                {
                    discountAmount.textContent = "-" + Shopify.formatMoney(Math.round(totalDiscount));
                    orderDiscountRow.style.display = "";
                }
            }
        }
        else if (orderDiscountRow)
        {
            orderDiscountRow.style.display = "none";
        }
    }

    initRedesignedCart();
    // Autoship switches disabled for now
    // setUpRedesignedCartAutoshipSwitches();
    setUpCartEventsWellEasy();
    updateHealthyAreasBanner(cartData);
}

function updateHealthyAreasBanner(cart)
{
    const cartData = cart.cart || cart;
            const l1Handles = ['food', 'snacks', 'drinks', 'supplements', 'household', 'personal-care'];
            const householdAliases = ['household', 'home'];
    var coveredCount = 0;
    const categoryHasItems = {};
    const banner = document.querySelector('.healthy-areas-banner');
    var h = 0;

    for (h = 0; h < l1Handles.length; h++)
    {
        categoryHasItems[l1Handles[h]] = false;
    }

    if (cartData.items && cartData.items.length)
    {
        const cartItemsDom = document.querySelectorAll('.we_cart_item[data-l1-category]');
        var d = 0;

        for (d = 0; d < cartItemsDom.length; d++)
        {
            const cat = cartItemsDom[d].getAttribute('data-l1-category');
            if (cat && l1Handles.indexOf(cat) != -1)
            {
                categoryHasItems[cat] = true;
            }
            else if (cat && householdAliases.indexOf(cat) != -1)
            {
                categoryHasItems['household'] = true;
            }
        }

        for (var j = 0; j < cartData.items.length; j++)
        {
            const item = cartData.items[j];
            const isMembership = item.product_type && item.product_type.toLowerCase().indexOf('membership') != -1;
            const isGift = item.properties && item.properties._product_gift_type;

            if (!isMembership && !isGift && item.collections && item.collections.length > 0)
            {
                for (var k = 0; k < item.collections.length; k++)
                {
                    const handle = item.collections[k].handle;
                    if (l1Handles.indexOf(handle) != -1)
                    {
                        categoryHasItems[handle] = true;
                        break;
                    }
                    else if (householdAliases.indexOf(handle) != -1)
                    {
                        categoryHasItems['household'] = true;
                        break;
                    }
                }
            }
        }
    }

    for (h = 0; h < l1Handles.length; h++)
    {
        if (categoryHasItems[l1Handles[h]])
        {
            coveredCount++;
        }
    }

    if (banner)
    {
        const coveragePct = Math.round((coveredCount / l1Handles.length) * 100);
        const countEl = banner.querySelector('.healthy-areas-title');
        const pctEl = banner.querySelector('.healthy-areas-percent strong');
        const progressFill = banner.querySelector('.healthy-areas-progress-fill');
        const tagsContainer = banner.querySelector('.healthy-areas-tags');

        if (countEl)
        {
            countEl.textContent = coveredCount + (window.healthyAreasBannerConfig.coverageText || ' of 7 healthy home areas covered');
        }

        if (pctEl)
        {
            pctEl.textContent = coveragePct + '%';
        }

        if (progressFill)
        {
            progressFill.style.width = coveragePct + '%';
        }

        if (tagsContainer)
        {
            tagsContainer.innerHTML = '';

            const l1Names = ['Food Cupboard', 'Nuts & Seeds', 'Snacks', 'Drinks', 'Supplements', 'Home', 'Personal Care'];
            const l1Icons = ['🛒', '🥜', '🍫', '🥤', '💊', '🏠', '🧴'];

            for (var h = 0; h < l1Handles.length; h++)
            {
                const handle = l1Handles[h];
                const name = l1Names[h];
                const icon = l1Icons[h];
                const hasCategory = categoryHasItems[handle];
                var el = null;

                if (hasCategory)
                {
                    el = document.createElement('span');
                    el.className = 'healthy-areas-tag';
                    el.innerHTML = '<span aria-hidden="true">' + icon + '</span><span>' + name + '</span><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"></path></svg>';
                }
                else
                {
                    el = document.createElement('button');
                    el.type = 'button';
                    el.className = 'healthy-areas-tag-button';
                    el.setAttribute('aria-label', 'See recommendations for ' + name);
                    el.innerHTML = '<span aria-hidden="true">' + icon + '</span><span>' + name + '</span><span class="picks-count">' + (window.healthyAreasBannerConfig.picksText || '· 8 picks') + '</span><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12h14"></path><path d="M12 5v14"></path></svg>';
                }

                tagsContainer.appendChild(el);
            }
        }
    }
}

function moveCartSavingMessage()
{
    var savingMessage         = document.querySelector(".cart-saving-message");
    var targetContainer       = document.querySelector(".welleasy-new-cart-first");
    var existingClonedMessage = document.querySelector(".mobile-cloned-message");
    var clonedMessage         = null;

    if ( savingMessage && targetContainer )
    {
        if ( window.innerWidth <= 768 )
        {
            if ( !existingClonedMessage )
            {
                clonedMessage = savingMessage.cloneNode(true);
                clonedMessage.style.display = "block";
                clonedMessage.classList.add("mobile-cloned-message");
                targetContainer.appendChild(clonedMessage);
            }
        }
        else
        {
            if ( existingClonedMessage )
            {
                existingClonedMessage.remove();
            }
        }
    }
}

function checkQuizCartParam()
{
    var urlParams = new URLSearchParams(window.location.search);
    var quizcart  = urlParams.get("quizcart");
    var view      = urlParams.get("view");

    if (quizcart == "1" || view == "quizcart" || quizcart != null)
    {
        if (!document.querySelector(".welleasy-redesigned-cart"))
        {
            console.log("QuizCart parameter detected but standard cart shown - may need page reload");
        }
    }
}

function stripLiquidCartAttrFromCartPageButtons()
{
    var path    = ( window.location.pathname || "" ).replace( /\/$/, "" );
    var cart    = document.querySelector( ".welleasy-redesigned-cart" );
    var buttons = null;
    var i       = 0;

    if ( path == "/cart" && cart )
    {
        buttons = cart.querySelectorAll( "[data-ajax-cart-request-button].cart-quantity-value-change, [data-ajax-cart-request-button][title='Remove']" );
        for ( i = 0; i < buttons.length; i++ )
        {
            buttons[i].removeAttribute( "data-ajax-cart-request-button" );
        }
    }
}

var freeGiftEnforcing = false;
var freeGiftReadding = false;
var FREE_GIFT_SUBTOTAL_LIMIT = 6000;
var LOCKED_GIFT_KEY = "we_locked_gift";

function readLockedGiftRecord( )
{
    var record = null;
    var raw = null;
    try { raw = window.localStorage.getItem( LOCKED_GIFT_KEY ); } catch ( e ) { raw = null; }
    if ( raw )
    {
        try { record = JSON.parse( raw ); } catch ( e ) { record = null; }
    }
    return record;
}

function clearLockedGiftRecord( )
{
    try { window.localStorage.removeItem( LOCKED_GIFT_KEY ); } catch ( e ) { }
}

function seedLockedGiftFromQuizChoice( gifts )
{
    var meta    = null;
    var raw     = null;
    var locked  = null;
    var hasGift = false;
    if ( gifts && gifts.length > 0 )
    {
        hasGift = true;
    }
    if ( hasGift == false )
    {
        locked = readLockedGiftRecord( );
        if ( locked == null )
        {
            try { raw = window.localStorage.getItem( "we_quiz_free_gift_meta" ); } catch ( e ) {}
            if ( raw )
            {
                try { meta = JSON.parse( raw ); } catch ( e ) { meta = null; }
                if ( meta && meta.variantId && meta.title )
                {
                    try
                    {
                        window.localStorage.setItem( LOCKED_GIFT_KEY, JSON.stringify( {
                            handle: meta.handle || "",
                            title: meta.title,
                            image: meta.image || "",
                            variantId: meta.variantId
                        } ) );
                    }
                    catch ( e ) { }
                }
            }
        }
    }
}

function storeLockedGiftRecord( item )
{
    var image = "";
    if ( !item || !item.handle || !item.product_title )
    {
        return;
    }
    if ( item.featured_image )
    {
        image = item.featured_image.url || "";
    }
    try
    {
        window.localStorage.setItem( LOCKED_GIFT_KEY, JSON.stringify( {
            handle: item.handle,
            title: item.product_title,
            image: image,
            variantId: item.variant_id
        } ) );
    }
    catch ( e ) { }
}

function isQuizCartForGifts( cart )
{
    var quiz = false;
    var note = "";
    var i    = 0;
    var item = null;
    if ( window.location.pathname == "/pages/welleasy-quiz" )
    {
        quiz = true;
    }
    else if ( cart )
    {
        note = cart.note || "";
        if ( note.indexOf( "quiz_taken" ) != -1 )
        {
            quiz = true;
        }
        else if ( cart.items )
        {
            for ( i = 0; i < cart.items.length; i++ )
            {
                item = cart.items[ i ];
                if ( item.properties && item.properties._enhancedcommerce )
                {
                    quiz = true;
                    break;
                }
            }
        }
    }
    return quiz;
}

function filterTaggedQuizGifts( lines, idx, strip )
{
    var item   = null;
    var handle = "";
    if ( idx >= lines.length )
    {
        removeLockedGiftsSequentially( strip, 0 );
        return;
    }
    item = lines[ idx ];
    if ( item.properties && item.properties._quiz_gift == "true" )
    {
        strip.push( item );
        filterTaggedQuizGifts( lines, idx + 1, strip );
        return;
    }
    handle = item.handle || "";
    if ( !handle )
    {
        filterTaggedQuizGifts( lines, idx + 1, strip );
        return;
    }
    fetch( "/products/" + handle + ".js", { headers: { "Accept": "application/json" } } )
    .then( function QuizGiftTag_Response( response ) { return response.json( ); } )
    .then( function QuizGiftTag_Done( product )
    {
        var tags   = ( product && product.tags ) || [ ];
        var i      = 0;
        var tagged = false;
        for ( i = 0; i < tags.length; i++ )
        {
            if ( String( tags[ i ] ).toLowerCase( ) == "quiz-gift" )
            {
                tagged = true;
                break;
            }
        }
        if ( tagged )
        {
            strip.push( item );
        }
        filterTaggedQuizGifts( lines, idx + 1, strip );
    } )
    .catch( function QuizGiftTag_Error( ) { filterTaggedQuizGifts( lines, idx + 1, strip ); } );
}

function memberNow( )
{
    var member = document.body.classList.contains( "has-inveterate-subscriber" );
    if ( member != true && document.querySelector( '[data-is-member="true"]' ) != null )
    {
        member = true;
    }
    return member;
}

function enforceFreeGiftRules( )
{
    if ( freeGiftEnforcing )
    {
        return;
    }
    freeGiftEnforcing = true;
    fetch( "/cart.js", { headers: { "Accept": "application/json" } } )
    .then( function FreeGiftRules_Read( response ) { return response.json( ); } )
    .then( function FreeGiftRules_Decide( cart )
    {
        var locked     = [ ];
        var quizMarked = [ ];
        var quizGifts  = [ ];
        var i          = 0;
        var item       = null;
        var hasGift    = false;
        var member     = memberNow( );
        for ( i = 0; i < cart.items.length; i++ )
        {
            item = cart.items[ i ];
            if ( item.properties && item.properties._product_gift_type == "free_gift" )
            {
                if ( item.properties._quiz_gift == "true" )
                {
                    quizMarked.push( item );
                }
                else
                {
                    locked.push( item );
                }
            }
        }
        hasGift = locked.length > 0;
        if ( member )
        {
            if ( quizMarked.length > 0 )
            {
                removeLockedGiftsSequentially( quizMarked, 0 );
            }
            filterTaggedQuizGifts( locked, 0, [ ] );
        }
        else
        {
            if ( isQuizCartForGifts( cart ) == false )
            {
                seedLockedGiftFromQuizChoice( locked.concat( quizMarked ) );
            }
            quizGifts = locked.concat( quizMarked );
            if ( cart.items_subtotal_price < FREE_GIFT_SUBTOTAL_LIMIT )
            {
                if ( quizGifts.length > 0 )
                {
                    storeLockedGiftRecord( quizGifts[ 0 ] );
                    removeLockedGiftsSequentially( quizGifts, 0 );
                }
                else
                {
                    if ( isQuizCartForGifts( cart ) == false )
                    {
                        renderLockedGiftTeaser( cart );
                    }
                    freeGiftEnforcing = false;
                }
                return;
            }
        }
        console.log( "[WE LockedGift] Enforce", { gifts: locked.length, quizMarked: quizMarked.length, subtotal: cart.items_subtotal_price, member: member, quiz: isQuizCartForGifts( cart ) } );
        if ( !hasGift && quizMarked.length == 0 && cart.items_subtotal_price >= FREE_GIFT_SUBTOTAL_LIMIT )
        {
            readdLockedGift( );
            freeGiftEnforcing = false;
            return;
        }
        if ( !hasGift )
        {
            freeGiftEnforcing = false;
            return;
        }
        if ( cart.items_subtotal_price >= FREE_GIFT_SUBTOTAL_LIMIT )
        {
            clearLockedGiftRecord( );
            freeGiftEnforcing = false;
            return;
        }
        if ( locked.length > 0 )
        {
            storeLockedGiftRecord( locked[ 0 ] );
        }
        freeGiftEnforcing = false;
        return;
    } )
    .catch( function FreeGiftRules_Error( ) { freeGiftEnforcing = false; } );
}

function readdLockedGift( )
{
    var record = readLockedGiftRecord( );
    var payload = null;
    if ( freeGiftReadding || !record || !record.variantId )
    {
        return;
    }
    freeGiftReadding = true;
    payload = { items: [ { id: Number( record.variantId ), quantity: 1, properties: { "_product_gift_type": "free_gift" } } ] };
    fetch( "/cart/add.js?sections=cart-drawer-section,cart-products-auto-render,welleasy-new-cart-template,welleasy-new-old-cart", {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify( payload )
    } )
    .then( function GiftReadd_Response( response ) { return response.json( ); } )
    .then( function GiftReadd_Done( nextCart )
    {
        freeGiftReadding = false;
        if ( window.location.pathname == "/cart" )
        {
            window.location.reload( );
        }
        else
        {
            refreshCartAfterGiftMutation( nextCart );
        }
    } )
    .catch( function GiftReadd_Error( )
    {
        freeGiftReadding = false;
        clearLockedGiftRecord( );
    } );
}

function refreshCartAfterGiftMutation( nextCart )
{
    refreshShopifyCartSnapshot( nextCart );
    updateRedesignedCartContent( nextCart );
    updateCartDrawer( nextCart );
    recheckAllRecsQtyState( );
}

function removeLockedGiftsSequentially( gifts, idx )
{
    var params = "";
    if ( idx >= gifts.length )
    {
        freeGiftEnforcing = false;
        return;
    }
    params = "id=" + gifts[ idx ].variant_id + "&quantity=0&sections=cart-drawer-section,cart-products-auto-render,welleasy-new-cart-template,welleasy-new-old-cart";
    fetch( "/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded", "Accept": "application/json" },
        body: params
    } )
    .then( function FreeGiftRemove_Response( response ) { return response.json( ); } )
    .then( function FreeGiftRemove_Done( nextCart )
    {
        if ( idx == gifts.length - 1 )
        {
            refreshCartAfterGiftMutation( nextCart );
            renderLockedGiftTeaser( nextCart );
        }
        removeLockedGiftsSequentially( gifts, idx + 1 );
    } )
    .catch( function FreeGiftRemove_Error( ) { freeGiftEnforcing = false; } );
}

function renderLockedGiftTeaser( cart )
{
    var oldTeaser = document.querySelector( ".we-locked-gift" );
    var items = [ ];
    var subtotal = 0;
    var hasGift = false;
    var record = null;
    var container = null;
    var firstGroup = null;
    var i = 0;
    var remaining = 0;
    var pct = 0;
    var wrap = null;
    var img = null;
    var body = null;
    var title = null;
    var panel = null;
    var label = null;
    var icon = null;
    var text = null;
    var track = null;
    var fill = null;

    if ( oldTeaser && oldTeaser.parentNode )
    {
        oldTeaser.parentNode.removeChild( oldTeaser );
    }

    if ( !cart || !cart.items )
    {
        return;
    }

    if ( memberNow( ) )
    {
        return;
    }

    items = cart.items;
    subtotal = cart.items_subtotal_price || 0;

    for ( i = 0; i < items.length; i++ )
    {
        if ( items[ i ].properties && items[ i ].properties._product_gift_type == "free_gift" )
        {
            hasGift = true;
            break;
        }
    }

    // Never clears the record here: this render may run on a stale cart
    // object (overlapping re-renders). Record lifecycle belongs to
    // enforceFreeGiftRules, which always reads a fresh /cart.js fetch.
    if ( hasGift )
    {
        return;
    }

    if ( subtotal >= FREE_GIFT_SUBTOTAL_LIMIT )
    {
        return;
    }

    record = readLockedGiftRecord( );
    if ( !record )
    {
        return;
    }

    container = document.querySelector( ".welleasy-redesigned-cart .cart-products-items-container" );
    if ( !container )
    {
        container = document.querySelector( ".cart-products-items-container" );
    }
    console.log( "[WE LockedGift] Teaser check", { hasGift: hasGift, subtotal: subtotal, hasRecord: record != null, hasContainer: container != null } );
    if ( !container )
    {
        return;
    }

    remaining = FREE_GIFT_SUBTOTAL_LIMIT - subtotal;
    pct = Math.min( Math.round( subtotal / FREE_GIFT_SUBTOTAL_LIMIT * 100 ), 100 );

    wrap = document.createElement( "div" );
    wrap.className = "we-locked-gift";

    img = document.createElement( "img" );
    img.className = "we-locked-gift__image";
    img.setAttribute( "src", record.image );
    img.setAttribute( "alt", record.title );
    img.setAttribute( "loading", "lazy" );
    wrap.appendChild( img );

    body = document.createElement( "div" );
    body.className = "we-locked-gift__body";
    wrap.appendChild( body );

    title = document.createElement( "div" );
    title.className = "we-locked-gift__title";
    title.textContent = record.title;
    body.appendChild( title );

    panel = document.createElement( "div" );
    panel.className = "we-locked-gift__panel";
    body.appendChild( panel );

    label = document.createElement( "div" );
    label.className = "we-locked-gift__label";
    panel.appendChild( label );

    icon = document.createElement( "span" );
    icon.className = "we-locked-gift__icon";
    icon.innerHTML = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"18\" height=\"18\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><rect x=\"3\" y=\"8\" width=\"18\" height=\"4\"></rect><path d=\"M12 8v13M5 12v9h14v-9M12 8s-1.5-5-4.5-5S5 8 12 8zm0 0s1.5-5 4.5-5S19 8 12 8z\"></path></svg>";
    label.appendChild( icon );

    text = document.createElement( "span" );
    text.textContent = "Spend " + Shopify.formatMoney( remaining ) + " more to unlock this gift";
    label.appendChild( text );

    track = document.createElement( "div" );
    track.className = "we-locked-gift__track";
    panel.appendChild( track );

    fill = document.createElement( "div" );
    fill.className = "we-locked-gift__fill";
    fill.style.width = pct + "%";
    track.appendChild( fill );

    // Gift rows render directly ahead of the category groups, so the teaser
    // takes the first group as its slot. No item math: children are groups.
    firstGroup = container.querySelector( ".category-section" );
    if ( firstGroup )
    {
        container.insertBefore( wrap, firstGroup );
    }
    else
    {
        container.prepend( wrap );
    }
}

function initRedesignedCartOnLoad()
{
    var accountFlag = localStorage.getItem( "quiz_account_creation" );

    if ( accountFlag )
    {
        localStorage.setItem( "quiz_reached_cart", "true" );
        localStorage.removeItem( "quiz_account_creation" );
    }

    var quizCompleted = localStorage.getItem( "quiz_reached_cart" );
    var cartState = getCartState();

    if ( !quizCompleted && cartState && cartState.cart && cartState.cart.items )
    {
        for ( var qi = 0; qi < cartState.cart.items.length; qi++ )
        {
            if ( cartState.cart.items[ qi ].properties && cartState.cart.items[ qi ].properties._enhancedcommerce )
            {
                localStorage.setItem( "quiz_reached_cart", "true" );
                quizCompleted = "true";
                break;
            }
        }
    }

    if ( quizCompleted && cartState && cartState.cart && cartState.cart.item_count == 0 )
    {
        localStorage.removeItem( "quiz_reached_cart" );
        localStorage.removeItem( "welleasy_onboarding_quiz_state" );
        localStorage.removeItem( "welleasy_onboarding_quiz_progress" );
    }

    enforceFreeGiftRules();

    moveCartSavingMessage();
    window.addEventListener("resize", moveCartSavingMessage);
    checkQuizCartParam();

    initRedesignedCart();

    // Get initial cart state and update content
    var cartState = getCartState();
    if (cartState && cartState.cart)
    {
        updateRedesignedCartContent(cartState.cart);
        renderLockedGiftTeaser(cartState.cart);
    }
    
    // Base cart handles quantity selectors via setUpCartEventsWellEasy()
    // Autoship switches disabled for now
    // setUpRedesignedCartAutoshipSwitches();

    subscribeToCartStateUpdate(handleCartStateUpdate);

    document.addEventListener("liquid-ajax-cart:request-end", handleCartRequestEnd);

    var cartContainer = document.querySelector(".welleasy-redesigned-cart");
    if (cartContainer)
    {
        var observer = new MutationObserver(handleMutationForReinit);
        observer.observe(cartContainer, { childList: true, subtree: true });
    }
}

function InitCartPageOnly( )
{
    var path;

    path = ( window.location.pathname || "" ).replace( /\/$/, "" );

    if ( path == "/cart" )
    {
        InitCartPageOnly_StripNow( );
        InitCartPageOnly_OverrideDrawer( );
    }

}

function InitCartPageOnly_StripNow( )
{
    setTimeout( InitCartPageOnly_StripNow_Async, 0 );
}

function InitCartPageOnly_StripNow_Async( )
{
    stripLiquidCartAttrFromCartPageButtons( );
}

function InitCartPageOnly_OverrideDrawer( )
{
    var originalUpdateCartDrawer;
    var sectionsParam;

    originalUpdateCartDrawer = window.updateCartDrawer;
    sectionsParam            = "cart-drawer-section,cart-products-auto-render,welleasy-new-cart-template,welleasy-new-old-cart";

    if ( originalUpdateCartDrawer )
    {
        window.updateCartDrawer = function CartPageUpdateCartDrawer( cartData )
        {
            InitCartPageOnly_HandleDrawerUpdate( originalUpdateCartDrawer, sectionsParam, cartData );
        };
    }

}

function InitCartPageOnly_HandleDrawerUpdate( originalUpdateCartDrawer, sectionsParam, cartData )
{
    var merged;
    var missingSections;

    merged          = cartData;
    var activeSection = getActiveCartSectionName();
    missingSections = ( !merged || !merged.sections || !merged.sections[ activeSection ] );

    if ( missingSections )
    {
        fetch( "/?sections=" + sectionsParam )
            .then( InitCartPageOnly_ParseSections )
            .then( function InitCartPageOnly_ApplyFetched( sections )
            {
                var updated;

                updated = Object.assign( { }, merged || { }, { sections: sections } );

                originalUpdateCartDrawer( updated );
                updateRedesignedCartContent( updated.cart || updated );
            })
            .catch( function InitCartPageOnly_Fallback( )
            {
                originalUpdateCartDrawer( cartData );
            });
    }
    else
    {
        originalUpdateCartDrawer( merged );
        updateRedesignedCartContent( merged.cart || merged );
    }

}

function InitCartPageOnly_ParseSections( response )
{
    return response.json( );
}

function rebindCartEventsAfterUpdate( cart )
{
    /* JUSTIFIED: Wait for DOM update after cart section HTML replacement */
    setTimeout( rebindCartHandlers, 200 );
}

function rebindCartHandlers( )
{
    setUpCartEventsWellEasy( );
}

function wrapUpdateRedesignedCartContent( )
{
    var original = updateRedesignedCartContent;

    updateRedesignedCartContent = function wrappedUpdateRedesignedCartContent( cart )
    {
        original( cart );
        rebindCartEventsAfterUpdate( cart );
    };
}

function initCartEventsRebinding( )
{
    wrapUpdateRedesignedCartContent( );

    /* JUSTIFIED: Cart JS may not be fully ready on initial page load */
    if ( document.readyState == "loading" )
    {
        function onDomReadyForRebind()
        {
            setTimeout( rebindCartHandlers, 500 );
        }

        document.addEventListener( "DOMContentLoaded", onDomReadyForRebind );
    }
    else
    {
        setTimeout( rebindCartHandlers, 500 );
    }
}

function bindQuizCheckoutTrigger( )
{
    const trigger = document.querySelector( ".js-quiz-upsell-trigger" );

    if ( trigger )
    {
        trigger.removeEventListener( "click", onQuizCheckoutTrigger );
        trigger.addEventListener( "click", onQuizCheckoutTrigger );
    }
}

function onQuizCheckoutTrigger( e )
{
    const view = document.querySelector( ".quiz-autoship-view" );
    const isActive = view && view.classList.contains( "cart-upsell-active" );

    if ( isActive )
    {
        var isLoggedIn = document.querySelector( ".welleasy-new-cart-wrapper" );
        var loggedIn   = isLoggedIn && isLoggedIn.getAttribute( "data-customer-logged-in" ) == "true";

        if ( loggedIn )
        {
            window.location.href = "/checkout";
        }
        else
        {
            window.location.href = "/account/register?flow=cart";
        }
    }
    else
    {
        e.preventDefault( );

        if ( view )
        {
            view.classList.add( "cart-upsell-active" );
            const parent = view.closest( ".welleasy-redesigned-cart" );

            if ( parent )
            {
                parent.classList.add( "cart-upsell-active" );
            }

            document.body.classList.add( "cart-upsell-active" );
            sessionStorage.setItem( "quiz_upsell_active", "true" );

            const healthyHome = document.querySelector( ".healthy-home-recommendations" );
            const membersLove = document.querySelector( ".members-love-section" );

            if ( healthyHome )
            {
                healthyHome.style.display = "none";
            }

            if ( membersLove )
            {
                membersLove.style.display = "none";
            }
        }
    }
}

function populateQuizDrawerFromRow( drawer, row )
{
    var image       = row.getAttribute( "data-product-image" );
    var title       = row.getAttribute( "data-product-title" );
    var description = row.getAttribute( "data-product-description" );
    var drawerImg   = drawer.querySelector( ".we-quiz-drawer__img" );
    var drawerIng   = drawer.querySelector( ".we-quiz-drawer__ingredients" );
    var drawerWhy   = drawer.querySelector( ".we-quiz-drawer__why-shown-product" );
    var drawerTitle = drawer.querySelector( ".we-quiz-drawer__title" );

    if ( image && drawerImg )
    {
        drawerImg.src = image;
        drawerImg.alt = title || "";
    }

    if ( description && drawerIng )
    {
        drawerIng.innerHTML = description;
    }

    if ( title && drawerWhy )
    {
        drawerWhy.textContent = title;
    }

    if ( title && drawerTitle )
    {
        drawerTitle.textContent = title;
    }
}

function fetchProductForQuizDrawer( productHandle, drawer )
{
    var drawerIng     = drawer.querySelector( ".we-quiz-drawer__ingredients" );
    var drawerNutr    = drawer.querySelector( ".we-quiz-drawer__nutrition" );
    var drawerVendor  = drawer.querySelector( ".we-quiz-drawer__vendor" );

    fetch( "/products/" + productHandle + ".js" )
        .then( function parseProductResponse( r )
        {
            return r.json( );
        })
        .then( function populateDrawerProductData( product )
        {
            if ( product.description && drawerIng )
            {
                drawerIng.innerHTML = product.description;
            }

            if ( product.description && drawerNutr )
            {
                drawerNutr.innerHTML = product.description;
            }

            if ( product.vendor && drawerVendor )
            {
                drawerVendor.textContent = product.vendor;
            }

            var tags = typeof product.tags == "string"
                ? product.tags.split( "," ).map( function trimTag( t )
                {
                    return t.trim( );
                })
                : ( product.tags || [] );

            var collIds = [];

            if ( product.collections )
            {
                for ( var c = 0; c < product.collections.length; c++ )
                {
                    collIds.push( product.collections[c].id );
                }
            }

            populateDrawerTags( drawer, tags );
            loadDrawerReviews( productHandle );
        })
        .catch( function handleProductFetchError( ) { } );
}

function populateQuizDrawerReasons( drawer, row, title )
{
    var reasonsData   = row.getAttribute( "data-ec-reasons" ) || row.getAttribute( "data-ec-dev-reasons" );
    var reasons       = [];
    var drawerWhyProd = drawer.querySelector( ".we-quiz-drawer__why-shown-product" );
    var drawerWhyReas = drawer.querySelector( ".we-quiz-drawer__why-shown-reasons" );
    var drawerWhyShow = drawer.querySelector( ".we-quiz-drawer__why-shown" );

    if ( reasonsData )
    {
        try
        {
            reasons = JSON.parse( reasonsData );
        }
        catch ( err )
        {
            reasons = [];
        }

        if ( !Array.isArray( reasons ) )
        {
            reasons = [];
        }
    }

    if ( reasons.length > 0 && drawerWhyReas && drawerWhyShow )
    {
        if ( drawerWhyProd )
        {
            drawerWhyProd.textContent = title || "";
        }

        drawerWhyReas.innerHTML = "";

        var i;
        var p;

        for ( i = 0; i < reasons.length; i++ )
        {
            p = document.createElement( "p" );
            p.textContent = reasons[i];
            drawerWhyReas.appendChild( p );
        }

        drawerWhyShow.removeAttribute( "hidden" );
    }
    else if ( drawerWhyShow )
    {
        drawerWhyShow.setAttribute( "hidden", "hidden" );
    }
}

function openQuizDrawer( drawer )
{
    drawer.classList.add( "we-quiz-drawer--open" );
    drawer.setAttribute( "aria-hidden", "false" );
    document.body.classList.add( "we-quiz-drawer-open" );

    var panel    = drawer.querySelector( ".we-quiz-drawer__panel" );
    var backdrop = drawer.querySelector( ".we-quiz-drawer-backdrop" );

    if ( panel )
    {
        panel.scrollTop = 0;
    }

    if ( backdrop )
    {
        backdrop.classList.add( "we-quiz-drawer-backdrop--visible" );
    }
}

function closeQuizDrawer( drawer )
{
    drawer.classList.remove( "we-quiz-drawer--open" );
    drawer.setAttribute( "aria-hidden", "true" );
    document.body.classList.remove( "we-quiz-drawer-open" );

    var backdrop = drawer.querySelector( ".we-quiz-drawer-backdrop" );

    if ( backdrop )
    {
        backdrop.classList.remove( "we-quiz-drawer-backdrop--visible" );
    }
}

function onCartDocumentClick( e )
{
    var reasonBtn = e.target.closest( ".we-quiz-card__reason" );

    if ( reasonBtn )
    {
        var drawer = document.getElementById( "cartQuizDrawer" );

        if ( !drawer )
        {
            return;
        }

        var row = reasonBtn.closest( ".products-in-cart" );

        if ( !row )
        {
            return;
        }

        var productHandle = row.getAttribute( "data-product-handle" );
        var title         = row.getAttribute( "data-product-title" );

        populateQuizDrawerFromRow( drawer, row );

        if ( productHandle )
        {
            fetchProductForQuizDrawer( productHandle, drawer );
        }

        populateQuizDrawerReasons( drawer, row, title );
        openQuizDrawer( drawer );
        return;
    }

    var pickerBtn = e.target.closest( ".we-quiz-card__picker" );

    if ( pickerBtn )
    {
        var panel = document.querySelector( ".we-quiz-picker-panel[data-line=\"" + pickerBtn.getAttribute( "data-line" ) + "\"]" );

        if ( panel )
        {
            panel.classList.remove( "hidden" );
        }

        return;
    }

    var pickerCloseBtn = e.target.closest( ".we-quiz-picker-close" );

    if ( pickerCloseBtn )
    {
        var pickerPanel = pickerCloseBtn.closest( ".we-quiz-picker-panel" );

        if ( pickerPanel )
        {
            pickerPanel.classList.add( "hidden" );
        }

        return;
    }

    var pickerOverlay = e.target.closest( ".we-quiz-picker-overlay" );

    if ( pickerOverlay )
    {
        var overlayPanel = pickerOverlay.closest( ".we-quiz-picker-panel" );

        if ( overlayPanel )
        {
            overlayPanel.classList.add( "hidden" );
        }

        return;
    }

    var shopSimilarBtn = e.target.closest( ".we-quiz-card__shop-similar" );

    if ( shopSimilarBtn )
    {
        var productId = shopSimilarBtn.getAttribute( "data-product-id" );
        var popup = document.querySelector( ".we-shop-similar-popup[data-similar-product-id=\"" + productId + "\"]" );

        if ( popup )
        {
            popup.classList.remove( "hidden" );
            loadShopSimilarWidget( popup, productId );
        }

        return;
    }

    var shopSimilarClose = e.target.closest( ".we-shop-similar-close" );

    if ( shopSimilarClose )
    {
        var popup = shopSimilarClose.closest( ".we-shop-similar-popup" );
        closeShopSimilarPopup( popup );
        return;
    }

    var shopSimilarOverlay = e.target.closest( ".we-shop-similar-overlay" );

    if ( shopSimilarOverlay )
    {
        var popup = shopSimilarOverlay.closest( ".we-shop-similar-popup" );
        closeShopSimilarPopup( popup );
        return;
    }

    var closeBtn = e.target.closest( "[data-we-quiz-drawer-close]" );

    if ( closeBtn )
    {
        var drawerToClose = closeBtn.closest( ".we-quiz-drawer" ) || document.getElementById( "cartQuizDrawer" );

        if ( drawerToClose )
        {
            closeQuizDrawer( drawerToClose );
        }

        return;
    }
}

function onQuizAreasToggleClick( e )
{
    var toggle = e.target.closest( ".quiz-areas-toggle" );

    if ( !toggle )
    {
        return;
    }

    var banner = toggle.closest( ".quiz-areas-banner" );

    banner.classList.toggle( "areas-collapsed" );

    var span = toggle.querySelector( "span" );

    if ( span )
    {
        span.textContent = banner.classList.contains( "areas-collapsed" ) ? "Show areas" : "Hide areas";
    }
}

function updateManageIndividuallyButtons( switchTo )
{
    var allAutoship = document.querySelectorAll( ".manage-toggle-btn[data-action=\"autoship\"]" );
    var allOnetime  = document.querySelectorAll( ".manage-toggle-btn[data-action=\"onetime\"]" );

    if ( switchTo == "autoship" )
    {
        allAutoship.forEach( function activateAutoshipBtn( b )
        {
            b.classList.add( "active" );
        });
        allOnetime.forEach( function deactivateOnetimeBtn( b )
        {
            b.classList.remove( "active" );
        });
    }
    else
    {
        allAutoship.forEach( function deactivateAutoshipBtn( b )
        {
            b.classList.remove( "active" );
        });
        allOnetime.forEach( function activateOnetimeBtn( b )
        {
            b.classList.add( "active" );
        });
    }
}

function collectDeliveryChanges( switchTo )
{
    var cbs        = document.querySelectorAll( ".sidecart-autoship-row input[name=\"cart-item-selling-plan\"]" );
    var wantChecked = ( switchTo == "autoship" );
    var seen       = {};
    var changes    = [];

    cbs.forEach( function collectChange( cb )
    {
        if ( cb.checked == wantChecked )
        {
            return;
        }

        var variantId = cb.getAttribute( "data-variant" );

        if ( !variantId || seen[variantId] )
        {
            return;
        }

        seen[variantId] = true;

        changes.push({
            variantId:     variantId,
            sellingPlanId: wantChecked ? cb.value : null
        });
    });

    return changes;
}

function showQuizDeliveryOverlay( )
{
    var overlay = document.createElement( "div" );

    overlay.className = "quiz-delivery-overlay";
    overlay.innerHTML = "<div class=\"quiz-delivery-overlay-spinner\"></div>";
    document.body.appendChild( overlay );
}

function removeQuizDeliveryOverlay( )
{
    var overlays = document.querySelectorAll( ".quiz-delivery-overlay" );

    overlays.forEach( function removeOverlay( el )
    {
        el.remove( );
    });
}

function removeQuizDeliveryLines( lineKeys )
{
    var updates = {};

    lineKeys.forEach( function setZero( key )
    {
        updates[key] = 0;
    });

    return fetch( "/cart/update.js", {
        method:  "POST",
        headers: { "Content-Type": "application/json" },
        body:    JSON.stringify({ updates: updates })
    });
}

function addQuizDeliveryLines( items )
{
    return fetch( "/cart/add.js", {
        method:  "POST",
        headers: { "Content-Type": "application/json" },
        body:    JSON.stringify({
            items:    items,
            sections: "cart-drawer-section,cart-products-auto-render,welleasy-new-cart-template,welleasy-new-old-cart"
        })
    });
}

function getQuizCartSectionName( )
{
    if ( document.getElementById( "shopify-section-welleasy-new-old-cart" ) )
    {
        return "welleasy-new-old-cart";
    }

    return "welleasy-new-cart-template";
}

function applyQuizDeliverySectionHtml( data )
{
    var sectionName = getQuizCartSectionName( );
    var sectionHtml = data.sections && data.sections[sectionName];

    if ( sectionHtml )
    {
        var container = document.getElementById( "shopify-section-" + sectionName );

        if ( container )
        {
            container.innerHTML = sectionHtml;

            var scheduleInput = container.querySelector( ".delivery-schedule-input" );

            if ( scheduleInput )
            {
                var autoshipCard = container.querySelector( ".delivery-toggle-autoship" );
                var onetimeCard  = container.querySelector( ".delivery-toggle-onetime" );

                if ( autoshipCard && onetimeCard )
                {
                    var isAutoship = scheduleInput.value == "autoship";
                    autoshipCard.classList.toggle( "active", isAutoship );
                    onetimeCard.classList.toggle( "active", !isAutoship );
                }
            }
        }
    }

    removeQuizDeliveryOverlay( );

    document.body.classList.add( "cart-upsell-active" );

    var cartWrapper = document.querySelector( ".welleasy-redesigned-cart" );

    if ( cartWrapper )
    {
        cartWrapper.classList.add( "cart-upsell-active" );
    }

    var view = document.querySelector( ".quiz-autoship-view" );

    if ( view )
    {
        view.classList.add( "cart-upsell-active" );
    }

    var healthyHome = document.querySelector( ".healthy-home-recommendations" );
    var membersLove = document.querySelector( ".members-love-section" );

    if ( healthyHome )
    {
        healthyHome.style.display = "none";
    }

    if ( membersLove )
    {
        membersLove.style.display = "none";
    }

    bindQuizCheckoutTrigger( );
}

function swapQuizDeliverySellingPlans( changes )
{
    fetch( "/cart.js" )
        .then( function parseCartResponse( response )
        {
            return response.json( );
        })
        .then( function processCart( cart )
        {
            var toRemove = [];
            var toAdd    = [];

            changes.forEach( function mapCartItem( change )
            {
                var line = cart.items.find( function matchVariant( item )
                {
                    return item.id == change.variantId;
                });

                if ( line )
                {
                    toRemove.push( line.key );

                    toAdd.push({
                        id:           line.variant_id,
                        quantity:     line.quantity,
                        selling_plan: change.sellingPlanId,
                        properties:   line.properties
                    });
                }
            });

            if ( toRemove.length == 0 )
            {
                removeQuizDeliveryOverlay( );
                return;
            }

            return removeQuizDeliveryLines( toRemove )
                .then( function onRemoveDone( )
                {
                    return addQuizDeliveryLines( toAdd );
                })
                .then( function parseAddResponse( response )
                {
                    return response.json( );
                })
                .then( applyQuizDeliverySectionHtml );
        })
        .catch( function onSwapError( )
        {
            removeQuizDeliveryOverlay( );
        });
}

function onQuizDeliveryToggleClick( e )
{
    var card = e.target.closest( ".delivery-toggle-view" );

    if ( !card )
    {
        return;
    }

    var section = card.closest( ".delivery-schedule-section" );

    if ( !section )
    {
        return;
    }

    var switchTo = card.classList.contains( "delivery-toggle-autoship" ) ? "autoship" : "onetime";

    var autoshipCard = section.querySelector( ".delivery-toggle-autoship" );
    var onetimeCard  = section.querySelector( ".delivery-toggle-onetime" );
    var hiddenInput  = section.querySelector( ".delivery-schedule-input" );

    if ( autoshipCard && onetimeCard )
    {
        autoshipCard.classList.toggle( "active", switchTo == "autoship" );
        onetimeCard.classList.toggle( "active", switchTo == "onetime" );

        if ( hiddenInput )
        {
            hiddenInput.value = switchTo;
        }
    }

    updateManageIndividuallyButtons( switchTo );

    var changes = collectDeliveryChanges( switchTo );

    if ( changes.length == 0 )
    {
        location.reload( );
        return;
    }

    showQuizDeliveryOverlay( );
    swapQuizDeliverySellingPlans( changes );
}

function onQuizReturnToCartClick( e )
{
    var btn = e.target.closest( ".quiz-autoship-return-cart" );

    if ( !btn )
    {
        return;
    }

    var view = document.querySelector( ".quiz-autoship-view" );

    if ( view )
    {
        view.classList.remove( "cart-upsell-active" );
        sessionStorage.removeItem( "quiz_upsell_active" );

        var parent = view.closest( ".welleasy-redesigned-cart" );

        if ( parent )
        {
            parent.classList.remove( "cart-upsell-active" );
        }

        document.body.classList.remove( "cart-upsell-active" );

        var healthyHome = document.querySelector( ".healthy-home-recommendations" );
        var membersLove = document.querySelector( ".members-love-section" );

        if ( healthyHome )
        {
            healthyHome.style.display = "";
        }

        if ( membersLove )
        {
            membersLove.style.display = "";
        }
    }
}

function bindManageIndividuallyToggle( )
{
    if ( document.body.dataset.manageIndividuallyBound == "true" )
    {
        return;
    }

    document.body.dataset.manageIndividuallyBound = "true";

    document.addEventListener( "click", function onManageIndividuallyClick( e )
    {
        var header = e.target.closest( ".manage-individually-header" );

        if ( !header )
        {
            return;
        }

        header.classList.toggle( "expanded" );

        var list = header.nextElementSibling;

        if ( list )
        {
            list.style.display = header.classList.contains( "expanded" ) ? "block" : "none";
        }
    });
}

function onManageToggleClick( e )
{
    var btn = e.target.closest( ".manage-toggle-btn" );

    if ( !btn )
    {
        return;
    }

    var row = btn.closest( ".manage-item-row" );

    if ( !row )
    {
        return;
    }

    var siblings = row.querySelectorAll( ".manage-toggle-btn" );

    siblings.forEach( function removeActive( b )
    {
        b.classList.remove( "active" );
    });

    btn.classList.add( "active" );

    var wantsAutoship = btn.getAttribute( "data-action" ) == "autoship";
    var lineItemId    = row.getAttribute( "data-line-item-id" );
    var cb            = document.querySelector( ".sidecart-autoship-row input[data-variant=\"" + lineItemId + "\"]" );

    if ( !cb || cb.checked == wantsAutoship )
    {
        return;
    }

    var url = cb.getAttribute( "data-action" ) || "";
    var m   = url.match( /line=(\d+)&quantity=(\d+)/ );

    if ( !m )
    {
        return;
    }

    var data = "quantity=" + m[2] + "&line=" + m[1];

    if ( wantsAutoship && cb.value )
    {
        data += "&selling_plan=" + cb.value;
    }
    else
    {
        data += "&selling_plan=";
    }

    data += "&sections=cart-drawer-section,cart-products-auto-render,welleasy-new-cart-template,welleasy-new-old-cart";

    sessionStorage.setItem( "quiz_upsell_active", "true" );

    jQuery.ajax({
        type:     "POST",
        url:      "/cart/change.js",
        data:     data,
        dataType: "json",
        success:  function onManageToggleSuccess( )
        {
            location.reload( );
        },
        error:    function onManageToggleError( )
        {
            location.reload( );
        }
    });
}

function restoreQuizUpsellState( )
{
    if ( sessionStorage.getItem( "quiz_upsell_active" ) != "true" )
    {
        return;
    }

    if ( window.location.pathname == "/cart" )
    {
        sessionStorage.removeItem( "quiz_upsell_active" );
        return;
    }

    var view = document.querySelector( ".quiz-autoship-view" );

    if ( view )
    {
        view.classList.add( "cart-upsell-active" );

        var parent = view.closest( ".welleasy-redesigned-cart" );

        if ( parent )
        {
            parent.classList.add( "cart-upsell-active" );
        }

        document.body.classList.add( "cart-upsell-active" );

        var healthyHome = document.querySelector( ".healthy-home-recommendations" );
        var membersLove = document.querySelector( ".members-love-section" );

        if ( healthyHome )
        {
            healthyHome.style.display = "none";
        }

        if ( membersLove )
        {
            membersLove.style.display = "none";
        }
    }
}

function initQuizCartUpsell( )
{
    initOnboardingQuizData( );
    bindQuizCheckoutTrigger( );
    bindManageIndividuallyToggle( );

    document.addEventListener( "click", onCartDocumentClick );
    document.addEventListener( "click", onQuizAreasToggleClick );
    document.addEventListener( "click", onQuizDeliveryToggleClick );
    document.addEventListener( "click", onQuizReturnToCartClick );
    document.addEventListener( "click", onManageToggleClick );

    restoreQuizUpsellState( );
}

function initOnboardingQuizData( )
{
    var dataEl = document.getElementById( "quiz-slides-data" );

    if ( !dataEl )
    {
        return;
    }

    var parsed;
    var slides;
    var csKeyMap;
    var i;

    try
    {
        parsed = JSON.parse( dataEl.textContent );
    }
    catch ( err )
    {
        return;
    }

    slides   = parsed.slides || [];
    csKeyMap = {};

    for ( i = slides.length - 1; i >= 0; i-- )
    {
        if ( slides[i].position == 0 )
        {
            csKeyMap[ slides[i].key ] = slides[i];
            slides.splice( i, 1 );
        }
    }

    window._onboardingQuizData           = window._onboardingQuizData || {};
    window._onboardingQuizData.slides    = slides;
    window._onboardingQuizData._csKeyMap = csKeyMap;
}

function closeShopSimilarPopup( popup )
{
    if ( popup )
    {
        popup.classList.add( "hidden" );

        if ( !popup.getAttribute( "data-interacted" ) )
        {
            return;
        }

        popup.removeAttribute( "data-interacted" );
    }

    fetch( "/cart.js", {
        method: "GET",
        headers: { "Accept": "application/json" }
    })
    .then( function onShopSimilarCartResponse( r ) { return r.json(); })
    .then( function onShopSimilarCartRefresh( cart )
    {
        refreshShopifyCartSnapshot( cart );
        updateCartDrawer( cart );
        recheckAllRecsQtyState();
    })
    .catch( function onShopSimilarCartError() {});
}

function loadShopSimilarWidget( popup, productId )
{
    var body = popup.querySelector( ".we-shop-similar-body" );
    var row = document.querySelector( ".we_cart_item[data-product-id=\"" + productId + "\"]" );
    var l3Handle = row ? ( row.getAttribute( "data-l3-collection" ) || "" ) : "";

    if ( !body || body.querySelector( ".healthy-home-product-card" ) )
    {
        return;
    }

    if ( l3Handle != "" )
    {
        console.log( "[Shop Similar] Product:", productId, "| L3:", l3Handle );
        loadShopSimilarFromL3( popup, productId, l3Handle );
    }
    else
    {
        console.log( "[Shop Similar] Product:", productId, "| No L3 match, PAB fallback" );
        loadShopSimilarWidgetEc( popup, productId );
    }
}

function loadShopSimilarFromL3( popup, productId, l3Handle )
{
    var body = popup.querySelector( ".we-shop-similar-body" );

    if ( !body )
    {
        return;
    }

    fetch( "/collections/" + l3Handle + "/products.json?limit=20&sort_by=best-sellers" )
        .then( function ShopSimilarL3_Response( response ) { return response.json( ); } )
        .then( function ShopSimilarL3_Render( data )
        {
            var products = ( data && data.products ) || [];
            var cartHandles = [];
            var cartItems = document.querySelectorAll( ".we_cart_item[data-product-handle]" );
            var c = 0;
            var p = 0;
            var added = 0;
            var firstVariant = null;

            for ( c = 0; c < cartItems.length; c++ )
            {
                cartHandles.push( cartItems[ c ].getAttribute( "data-product-handle" ) );
            }

            for ( p = 0; p < products.length && added < 8; p++ )
            {
                if ( cartHandles.indexOf( products[ p ].handle ) != -1 )
                {
                    continue;
                }

                firstVariant = products[ p ].variants && products[ p ].variants.length > 0 ? products[ p ].variants[ 0 ] : null;

                if ( !firstVariant || !firstVariant.available )
                {
                    continue;
                }

                body.insertAdjacentHTML( "beforeend", renderHealthyHomeProductCard( products[ p ], [] ) );
                added++;
            }

            var loading = body.querySelector( ".we-shop-similar-loading" );

            if ( loading )
            {
                loading.remove( );
            }

            console.log( "[Shop Similar] L3 pool:", products.length, "| Rendered:", added );

            if ( added > 0 )
            {
                body.style.display = "flex";
                bindAtcButtons( body );
                checkCartQtyState( body );
            }
            else
            {
                body.innerHTML = '<div class="we-shop-similar-empty"><p class="we-shop-similar-empty-text">No similar items found</p><p class="we-shop-similar-empty-sub">Try browsing our collection for more options</p></div>';
            }
        } )
        .catch( function ShopSimilarL3_Error( )
        {
            console.log( "[Shop Similar] L3 fetch failed, PAB fallback" );
            loadShopSimilarWidgetEc( popup, productId );
        } );
}

function loadShopSimilarWidgetEc( popup, productId )
{
    var body = popup.querySelector( ".we-shop-similar-body" );

    if ( body && !body.querySelector( ".healthy-home-product-card" ) )
    {
        var loadingText = body.querySelector( ".we-shop-similar-loading-text" );
        var loadingSpinner = body.querySelector( ".we-shop-similar-spinner" );

        setTimeout( function onTextPhaseComplete()
        {
            if ( loadingText ) { loadingText.classList.add( "hidden" ); }
            if ( loadingSpinner ) { loadingSpinner.classList.remove( "hidden" ); }
        }, 500 );

        window._enhancedCommerceQ._realPush( {
            "command" : "setCart",
            "cart" : { "items" : [ { "product_id" : productId } ] }
        } );

        if ( window.EC_CreateWidget )
        {
            var widget = EC_CreateWidget( {
                "type" : "people_also_bought",
                "name" : "PAB",
                "title" : "",
                "productsToShow" : "8"
            } );

            var wrapper = document.createElement( "div" );
            wrapper.style.display = "none";
            wrapper.setAttribute( "loading", "eager" );
            wrapper.appendChild( widget );
            body.appendChild( wrapper );

            var pollCount = 0;

            function pollForSimilarCards()
            {
                var ecCards = wrapper.querySelectorAll( ".ec-product-card, .product-grid__product-card" );
                var anyNew = false;

                var cartHandles = [];
                var cartItems = document.querySelectorAll( ".we_cart_item[data-product-handle]" );
                for ( var c = 0; c < cartItems.length; c++ )
                {
                    cartHandles.push( cartItems[c].getAttribute( "data-product-handle" ) );
                }

                for ( var i = 0; i < ecCards.length; i++ )
                {
                    if ( ecCards[i].getAttribute( "data-shop-similar-done" ) )
                    {
                        continue;
                    }

                    var productData = extractShopSimilarData( ecCards[i] );

                    if ( productData && productData.handle )
                    {
                        if ( cartHandles.indexOf( productData.handle ) != -1 )
                        {
                            ecCards[i].setAttribute( "data-shop-similar-done", "1" );
                            continue;
                        }

                        if ( productData.variants && productData.variants[0] && !productData.variants[0].available )
                        {
                            ecCards[i].setAttribute( "data-shop-similar-done", "1" );
                            continue;
                        }

                        var cardHtml = renderHealthyHomeProductCard( productData, [] );
                        body.insertAdjacentHTML( "beforeend", cardHtml );
                        ecCards[i].setAttribute( "data-shop-similar-done", "1" );
                        anyNew = true;
                    }
                }

                if ( anyNew )
                {
                    var loading = body.querySelector( ".we-shop-similar-loading" );

                    if ( loading )
                    {
                        loading.remove();
                    }

                    body.style.display = "flex";
                    bindAtcButtons( body );
                    checkCartQtyState( body );
                    pollCount = 0;
                }

                pollCount++;

                if ( pollCount >= 150 )
                {
                    var loading = body.querySelector( ".we-shop-similar-loading" );

                    if ( loading )
                    {
                        var spinner = loading.querySelector( ".we-shop-similar-spinner" );

                        if ( spinner )
                        {
                            spinner.classList.add( "hidden" );
                        }

                        if ( body.querySelector( ".healthy-home-product-card" ) )
                        {
                            loading.remove();
                        }
                        else
                        {
                            loading.innerHTML = '<p class="we-shop-similar-loading-text">Loading recommendations...</p>';
                            var fallbackSpinner = loading.querySelector( ".we-shop-similar-spinner" );
                            if ( fallbackSpinner ) { fallbackSpinner.classList.remove( "hidden" ); }

                            var cartHandles = [];
                            var cartItems = document.querySelectorAll( ".we_cart_item[data-product-handle]" );
                            for ( var c = 0; c < cartItems.length; c++ )
                            {
                                cartHandles.push( cartItems[c].getAttribute( "data-product-handle" ) );
                            }

                            fetchCollectionProducts( "first-order-push", function( err, products )
                            {
                                if ( err || !products || products.length == 0 )
                                {
                                    body.innerHTML = '<div class="we-shop-similar-empty"><p class="we-shop-similar-empty-text">No similar items found</p><p class="we-shop-similar-empty-sub">Try browsing our collection for more options</p></div>';
                                    return;
                                }

                                var added = 0;
                                for ( var p = 0; p < products.length && added < 8; p++ )
                                {
                                    if ( cartHandles.indexOf( products[p].handle ) != -1 ) { continue; }
                                    if ( products[p].variants && products[p].variants[0] && !products[p].variants[0].available ) { continue; }
                                    var cardHtml = renderHealthyHomeProductCard( products[p], [] );
                                    body.insertAdjacentHTML( "beforeend", cardHtml );
                                    added++;
                                }

                                var loadEl = body.querySelector( ".we-shop-similar-loading" );
                                if ( loadEl ) { loadEl.remove(); }

                                if ( added > 0 )
                                {
                                    body.style.display = "flex";
                                    bindAtcButtons( body );
                                    checkCartQtyState( body );
                                }
                                else
                                {
                                    body.innerHTML = '<div class="we-shop-similar-empty"><p class="we-shop-similar-empty-text">No similar items found</p><p class="we-shop-similar-empty-sub">Try browsing our collection for more options</p></div>';
                                }
                            } );
                        }
                    }

                    return;
                }

                if ( !anyNew )
                {
                    setTimeout( pollForSimilarCards, 100 );
                }
                else
                {
                    setTimeout( pollForSimilarCards, 500 );
                }
            }

            pollForSimilarCards();
        }
        else
        {
            function onShopSimilarEcReady()
            {
                window.removeEventListener( "enhancedcommerce:ready", onShopSimilarEcReady );
                loadShopSimilarWidget( popup, productId );
            }

            window.addEventListener( "enhancedcommerce:ready", onShopSimilarEcReady );
        }
    }
}

function extractShopSimilarData( ecCard )
{
    var title = ecCard.querySelector( ".ec-product-title" );
    var vendor = ecCard.querySelector( ".ec-product-vendor, .product-card__brand" );
    var priceEl = ecCard.querySelector( ".ec-product-regular-price, .product-card__price__discounted" );
    var img = ecCard.querySelector( "img[data-key=\"feature_image\"], img" );
    var variantId = ecCard.getAttribute( "data-variant-id" );
    var discountEl = ecCard.querySelector( ".product-card__discount" );
    var compareEl = ecCard.querySelector( ".product-card__price__full, .ec-product-compare-price" );

    if ( !title || !priceEl )
    {
        return null;
    }

    var handle = "";
    var dataRaw = ecCard.getAttribute( "data-product-data" );

    if ( dataRaw )
    {
        try
        {
            var parsed = JSON.parse( dataRaw );
            handle = ( parsed.url || "" ).replace( "/products/", "" ).split( "?" )[0];
        }
        catch ( e ) { }
    }

    if ( !handle )
    {
        var link = ecCard.querySelector( "a[href*=\"/products/\"]" );

        if ( link )
        {
            handle = link.getAttribute( "href" ).replace( "/products/", "" ).split( "?" )[0];
        }
    }

    var priceText = priceEl.textContent.replace( /[^\d.]/g, "" );
    var compareText = compareEl ? compareEl.textContent.replace( /[^\d.]/g, "" ) : "";
    var discountPct = 0;
    var isAvailable = true;
    var inventoryQty = "";
    var atcBtn = ecCard.querySelector( ".ec-add-to-cart" );
    var ecVariants = null;

    if ( atcBtn && atcBtn._product && atcBtn._product.variants )
    {
        ecVariants = atcBtn._product.variants;
    }

    if ( ecVariants )
    {
        var chosenVariant = null;
        var hasAvailable = false;

        for ( var v = 0; v < ecVariants.length; v++ )
        {
            if ( ecVariants[ v ].available == true )
            {
                hasAvailable = true;

                if ( !chosenVariant )
                {
                    chosenVariant = ecVariants[ v ];
                }
            }
        }

        if ( chosenVariant )
        {
            variantId = chosenVariant.id;
            priceText = String( ( chosenVariant.price / 100 ).toFixed( 2 ) );
            compareText = chosenVariant.compare_at_price ? String( ( chosenVariant.compare_at_price / 100 ).toFixed( 2 ) ) : "";
            inventoryQty = chosenVariant.inventory_quantity != null ? String( chosenVariant.inventory_quantity ) : "";
        }

        isAvailable = hasAvailable;
    }

    if ( discountEl && discountEl.textContent )
    {
        var match = discountEl.textContent.match( /(\d+)/ );

        if ( match )
        {
            discountPct = parseInt( match[1], 10 );
        }
    }

    if ( discountPct == 0 && compareText && priceText && compareText != priceText )
    {
        var comp = parseFloat( compareText );
        var price = parseFloat( priceText );

        if ( comp > 0 && price > 0 )
        {
            discountPct = Math.round( ( ( comp - price ) / comp ) * 100 );
        }
    }

    return {
        handle : handle,
        title : title.textContent.trim(),
        vendor : vendor ? vendor.textContent.trim() : "",
        images : img ? [ { src : img.getAttribute( "src" ) } ] : [],
        variants : [ {
            id : variantId || "",
            price : priceText || "0",
            compare_at_price : compareText || null,
            available : isAvailable,
            inventory_quantity : inventoryQty
        } ],
        tags : [],
        compare_at_price : compareText || null,
        discount_pct : discountPct
    };
}

function transformShopSimilarCards( body, wrapper )
{
    var ecCards = wrapper.querySelectorAll( ".ec-product-card, .product-grid__product-card" );
    var html = "";
    var transformed = false;
    var cartItems = document.querySelectorAll( ".we_cart_item[data-product-handle]" );
    var cartHandles = [];

    for ( var c = 0; c < cartItems.length; c++ )
    {
        cartHandles.push( cartItems[c].getAttribute( "data-product-handle" ) );
    }

    for ( var i = 0; i < ecCards.length; i++ )
    {
        if ( ecCards[i].getAttribute( "data-shop-similar-done" ) )
        {
            continue;
        }

        var productData = extractShopSimilarData( ecCards[i] );

        if ( productData && productData.handle )
        {
            var inCart = cartHandles.indexOf( productData.handle ) != -1;

            if ( inCart )
            {
                ecCards[i].setAttribute( "data-shop-similar-done", "1" );
            }
            else
            {
                html += renderHealthyHomeProductCard( productData, [] );
                ecCards[i].setAttribute( "data-shop-similar-done", "1" );
                transformed = true;
            }
        }
    }

    if ( transformed )
    {
        var loading = body.querySelector( ".we-shop-similar-loading" );

        if ( loading )
        {
            loading.remove( );
        }

        body.insertAdjacentHTML( "beforeend", html );
        body.style.display = "flex";
        bindAtcButtons( body );
        checkCartQtyState( body );
    }
}

function shopSimilarAddToCart( btn, card, vid )
{
    btn.classList.add( "healthy-home-product-card-atc--loading" );

    var params = "id=" + vid + "&quantity=1&properties[_ec_widget]=PAB";
    var ecSid = getEcSessionId( );

    if ( ecSid != "" )
    {
        params += "&properties[_enhancedcommerce]=" + encodeURIComponent( ecSid );
    }

    fetch( "/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded", "Accept": "application/json" },
        body: params
    })
    .then( function onAddResponse( r ) { if ( !r.ok ) throw new Error( "Add failed" ); return r.json(); })
    .then( function onAddSuccess( cart )
    {
        btn.classList.remove( "healthy-home-product-card-atc--loading" );
        trackEcAtcClick( "PAB", vid );
        card.classList.add( "has-qty" );
        renderQtySelector( card, 1, vid );
        refreshShopifyCartSnapshot( cart );
        recheckAllRecsQtyState();
    })
    .catch( function onAddError()
    {
        btn.classList.remove( "healthy-home-product-card-atc--loading" );
    });
}

function shopSimilarQtyMinus( card, vid )
{
    var qtyEl = card.querySelector( ".healthy-home-product-card-qty span" );
    var currentQty = parseInt( qtyEl.textContent, 10 );

    if ( currentQty <= 1 )
    {
        card.remove();
        fetch( "/cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/x-www-form-urlencoded", "Accept": "application/json" },
            body: "id=" + vid + "&quantity=0"
        })
        .then( function( r ) { return r.json(); })
        .then( function( cart )
        {
            refreshShopifyCartSnapshot( cart );
            recheckAllRecsQtyState();
        })
        .catch( function() {});
    }
    else
    {
        var newQty = currentQty - 1;
        fetch( "/cart/change.js", {
            method: "POST",
            headers: { "Content-Type": "application/x-www-form-urlencoded", "Accept": "application/json" },
            body: "id=" + vid + "&quantity=" + newQty
        })
        .then( function( r ) { return r.json(); })
        .then( function( cart )
        {
            qtyEl.textContent = newQty;
            renderQtySelector( card, newQty, vid );
            refreshShopifyCartSnapshot( cart );
            recheckAllRecsQtyState();
        })
        .catch( function() {});
    }
}

function shopSimilarQtyPlus( card, vid )
{
    var qtyEl = card.querySelector( ".healthy-home-product-card-qty span" );
    var newQty = parseInt( qtyEl.textContent, 10 ) + 1;

    fetch( "/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded", "Accept": "application/json" },
        body: "id=" + vid + "&quantity=" + newQty
    })
    .then( function( r ) { return r.json(); })
    .then( function( cart )
    {
        qtyEl.textContent = newQty;
        renderQtySelector( card, newQty, vid );
        refreshShopifyCartSnapshot( cart );
        recheckAllRecsQtyState();
    })
    .catch( function() {});
}

function onShopSimilarCartAction( e )
{
    var atcBtn = e.target.closest( ".we-shop-similar-body .healthy-home-product-card-atc" );
    var minusBtn = e.target.closest( ".we-shop-similar-body .healthy-home-product-card-qty [data-action=\"minus\"]" );
    var plusBtn = e.target.closest( ".we-shop-similar-body .healthy-home-product-card-qty [data-action=\"plus\"]" );

    if ( !atcBtn && !minusBtn && !plusBtn )
    {
        return;
    }

    e.stopPropagation();

    var popup = e.target.closest( ".we-shop-similar-popup" );
    if ( popup ) { popup.setAttribute( "data-interacted", "1" ); }

    var card = e.target.closest( ".healthy-home-product-card" );
    var atcEl = card ? card.querySelector( ".healthy-home-product-card-atc" ) : null;
    var vid = atcEl ? atcEl.getAttribute( "data-variant-id" ) : "";

    if ( atcBtn && vid )
    {
        shopSimilarAddToCart( atcBtn, card, vid );
    }
    else if ( minusBtn && card && vid )
    {
        shopSimilarQtyMinus( card, vid );
    }
    else if ( plusBtn && card && vid )
    {
        shopSimilarQtyPlus( card, vid );
    }
}

function SetCartBackButton( )
{
    return;
}

function WelleasyRedesignedCartOnDOMReady( )
{
    SetCartBackButton( );
    InitCartPageOnly( );
    initRedesignedCartOnLoad( );
    initCartEventsRebinding( );
    initQuizCartUpsell( );
    document.addEventListener( "click", onShopSimilarCartAction, true );

    window.addEventListener( "pageshow", function onCartPageShow( e )
    {
        bindQuizCheckoutTrigger( );
        restoreQuizUpsellState( );
    });

    window.addEventListener( "load", function onCartLoad( )
    {
        restoreQuizUpsellState( );
    });
}

document.addEventListener( "DOMContentLoaded", WelleasyRedesignedCartOnDOMReady );



